import * as THREE from './three/three.module.js';

import { generateTangents, ready } from './three/examples/jsm/libs/mikktspace.module.js';
import { mergeGeometries } from "../rt/BufferGeometryUtils.js";
import { BVH_Build_Iterative } from '../rt/BVH_Acc_Structure_Iterative_SAH_Builder.js'
import { initShaders } from '../rt_shaders.js'
import { VRButton } from './three/examples/jsm/webxr/VRButton.js';

import { Transformation3} from './transform.js';
import { BufferAllocator} from './allocator.js';
import { ParticleEngine } from './three/ParticleEngine.js';

import {RT_SPOT_LIGHT, RT_SPEC, RT_DIFF, RT_METALCOAT, RT_COAT, RT_CARCOAT, RT_REFR, RT_SKYBOX, RT_POINT_LIGHT,smoke_params,shot_params, EngineBase } from './engine_base.js';
import { meshsInfos } from '../cc.js';
import { Uint16BufferAttribute } from './three/three.module.js';
import {shader} from '../../shaders/raytrace_main.js'


const lineWith = 4096;
const lineSize = lineWith * 4;
const noMeshFlip = {x: false,y: false,z: false};


function MaterialObject() {
    // a list of material types and their corresponding numbers are found in the 'pathTracingCommon.js' file
    this.type = 1; // default is '1': diffuse type 		
    this.albedoTextureID = -1; // which diffuse map to use for model's color / '-1' = no textures are used
    this.normalTextureID = -1; // which diffuse map to use for model's color / '-1' = no textures are used
    this.color = new THREE.Color(1.0, 1.0, 1.0); // takes on different meanings, depending on 'type' above
    this.roughness = 0.0; // 0.0 to 1.0 range, perfectly smooth to extremely rough
    this.metalness = 1.0; // 0.0 to 1.0 range, usually either 0 or 1, either non-metal or metal
    this.opacity = 1.0;   // 0.0 to 1.0 range, fully transparent to fully opaque
    this.refractiveIndex = 1.0; // 1.0=air, 1.33=water, 1.4=clearCoat, 1.5=glass, etc.
}

class bigTex {

    constructor(renderer) {
        this.renderer = renderer;



        this.maxSize =  Math.min(8192 , this.renderer.capabilities.maxTextureSize);

        console.log('this.maxSize ' + this.maxSize);

        const img = new Image(this.maxSize, this.maxSize);

        this.tex = new THREE.Texture(img, THREE.Texture.DEFAULT_MAPPING, THREE.ClampToEdgeWrapping, THREE.ClampToEdgeWrapping, THREE.LinearFilter, THREE.LinearFilter, THREE.RGBAFormat, THREE.UnsignedByteType);

        
        /*
        this.buffer = new Uint8Array(this.maxSize * this.maxSize * 4);

        this.tex = new THREE.DataTexture( 	this.buffer, this.maxSize, this.maxSize,
                                            THREE.RGBAFormat,
                                            THREE.UnsignedByteType,
                                            THREE.Texture.DEFAULT_MAPPING,
                                            THREE.ClampToEdgeWrapping,
                                            THREE.ClampToEdgeWrapping,
                                            THREE.LinearFilter,
                                            THREE.LinearFilter,0,THREE.RGBAFormat);
        */

        this.tex.colorSpace = THREE.LinearSRGBColorSpace;
        this.tex.generateMipmaps = false;
        this.tex.flipY = true;
        this.tex.needsUpdate = true;


        this.curPos = new THREE.Vector2(0, 0);
        this.curRowH = 0;
    }

    
    addTexture(map) {

        //console.log('addTexture before ', JSON.stringify(this.curPos), map.image, this.tex);

        const tw = map.source.data.naturalWidth  > 0 ? map.source.data.naturalWidth  : map.source.data.width;
        const th = map.source.data.naturalHeight > 0 ? map.source.data.naturalHeight : map.source.data.height;

        if ((this.curPos.x + tw) > this.maxSize) {
            this.curPos.x = 0;
            this.curPos.y += this.curRowH;
            this.curRowH = 0;
        }

        if ((this.curPos.y + th) > this.maxSize)
            return null;

        const p = { x: this.curPos.x / this.maxSize, y: this.curPos.y / this.maxSize };
        const s = { x: tw / this.maxSize, y:  th / this.maxSize };

        if(!map.isCanvas){
            this.renderer.initTexture(map);
            this.renderer.copyTextureToTexture(this.curPos, map, this.tex, 0);
        }


        this.tex.needsUpdate = true;
        this.curPos.x += tw;
        this.curRowH = Math.max( th, this.curRowH);

        //console.log('addTexture after', JSON.stringify(this.curPos), map.image, this.tex)

        return { pos: p, size: s };
    }
}




const FIRST_CYLINDER = lineSize * 2;
const LAST_CYLINDER = FIRST_CYLINDER + lineSize;

const FIRST_SPHERE = lineSize * 3;
const LAST_SPHERE = FIRST_SPHERE + lineSize;

const FIRST_LIGHT = lineSize * 4;
const LAST_LIGHT = FIRST_LIGHT + lineSize;

const FIRST_BOX = lineSize * 5;
const LAST_BOX = FIRST_BOX + lineSize;

const FIRST_MAT = lineSize * 6;
const LAST_MAT = FIRST_MAT + lineSize;

const FIRST_TEXCOORD = lineSize * 8;
const LAST_TEXCOORD = FIRST_TEXCOORD + lineSize / 2;

const FIRST_TEXID = lineSize * 8 + lineSize / 2;
const LAST_TEXID = FIRST_TEXID + lineSize / 2;


const FIRST_GEOLIST = lineSize * 9;
const LAST_GEOLIST = FIRST_GEOLIST + lineSize;

class MeshCollision{

    constructor() {

        this.total_number_of_triangles = 0;
        this.total_number_of_aabs = 0;

    }
   
    updateSkinnedMeshBuffer(mesh, triArray, aabArrayBuffer, triangleMaterialMarkers, pathTracingMaterialList, materialCache) {

        const geo = mesh.geometry;

        const nTriangles = geo.index ? geo.index.count /3 : geo.attributes.position.count / 3;

        const aabArray = new Float32Array(nTriangles * 9);
        const totalWork = new Uint32Array(nTriangles);

        const triangle_b_box_min = new THREE.Vector3();
        const triangle_b_box_max = new THREE.Vector3();
        const triangle_b_box_centroid = new THREE.Vector3();

        const modelHasUVs = (geo.attributes.uv !== undefined) ? true : false;

        const vpa = new Float32Array(geo.attributes.position.array);
        const vta = modelHasUVs ? new Float32Array(geo.attributes.uv.array) : null;

        let vp0 = new THREE.Vector3();
        let vp1 = new THREE.Vector3();
        let vp2 = new THREE.Vector3();
        let vt0 = new THREE.Vector2();
        let vt1 = new THREE.Vector2();
        let vt2 = new THREE.Vector2();

        for (let i = 0; i < nTriangles; i++) {
            let materialNumber = 0;

            triangle_b_box_min.set(Infinity, Infinity, Infinity);
            triangle_b_box_max.set(-Infinity, -Infinity, -Infinity);

            for (let j = 0; j < pathTracingMaterialList.length; j++) {
                if (i < triangleMaterialMarkers[j]) {
                    materialNumber = j;
                    break;
                }
            }

            const i1 =  geo.index ? geo.index.array[i * 3 +0] : i * 3 + 0;
            const i2 =  geo.index ? geo.index.array[i * 3 +1] : i * 3 + 1;
            const i3 =  geo.index ? geo.index.array[i * 3 +2] : i * 3 + 2;

            // record vertex texture coordinates (UVs)
            if (modelHasUVs) {
                vt0.set(vta[i1 * 2 + 0], vta[i1 * 2 + 1]);
                vt1.set(vta[i2 * 2 + 0], vta[i2 * 2 + 1]);
                vt2.set(vta[i3 * 2 + 0], vta[i3 * 2 + 1]);
            }
            else {
                vt0.set(-1, -1);
                vt1.set(-1, -1);
                vt2.set(-1, -1);
            }
           
            // record vertex positions
            vp0.set(vpa[i1 * 3 + 0], vpa[i1 * 3 + 1], vpa[i1 * 3 + 2]);
            vp1.set(vpa[i2 * 3 + 0], vpa[i2 * 3 + 1], vpa[i2 * 3 + 2]);
            vp2.set(vpa[i3 * 3 + 0], vpa[i3 * 3 + 1], vpa[i3 * 3 + 2]);

            const vp0t = mesh.applyBoneTransform (i1, vp0);
            const vp1t = mesh.applyBoneTransform (i2, vp1);
            const vp2t = mesh.applyBoneTransform (i2, vp2);

            //slot 0
            triArray[16 *i + 0] = vp0t.x; // r or x
            triArray[16 *i + 1] = vp0t.y; // g or y 
            triArray[16 *i + 2] = vp0t.z; // b or z
            triArray[16 *i + 3] = vp1t.x; // a or w

            //slot 1
            triArray[16 *i + 4] = vp1t.y; // r or x
            triArray[16 *i + 5] = vp1t.z; // g or y
            triArray[16 *i + 6] = vp2t.x; // b or z
            triArray[16 *i + 7] = vp2t.y; // a or w

            //slot 2
            triArray[16 *i + 8] = vp2t.z; // r or x
            triArray[16 *i + 9] = materialCache[pathTracingMaterialList[materialNumber]].matId; // g or y
            triArray[16 *i + 10] = vt0.x; // b or z
            triArray[16 *i + 11] = vt0.y; // a or w

            //slot 3
            triArray[16 *i + 12] = vt1.x; // r or x
            triArray[16 *i + 13] = vt1.y; // g or y
            triArray[16 *i + 14] = vt2.x; // b or z
            triArray[16 *i + 15] = vt2.y; // a or w


            triangle_b_box_min.copy(triangle_b_box_min.min(vp0t));
            triangle_b_box_max.copy(triangle_b_box_max.max(vp0t));
            triangle_b_box_min.copy(triangle_b_box_min.min(vp1t));
            triangle_b_box_max.copy(triangle_b_box_max.max(vp1t));
            triangle_b_box_min.copy(triangle_b_box_min.min(vp2t));
            triangle_b_box_max.copy(triangle_b_box_max.max(vp2t));

            triangle_b_box_centroid.copy(triangle_b_box_min).add(triangle_b_box_max).multiplyScalar(0.5);

            aabArray[9 * i + 0] = triangle_b_box_min.x;
            aabArray[9 * i + 1] = triangle_b_box_min.y;
            aabArray[9 * i + 2] = triangle_b_box_min.z;
            aabArray[9 * i + 3] = triangle_b_box_max.x;
            aabArray[9 * i + 4] = triangle_b_box_max.y;
            aabArray[9 * i + 5] = triangle_b_box_max.z;
            aabArray[9 * i + 6] = triangle_b_box_centroid.x;
            aabArray[9 * i + 7] = triangle_b_box_centroid.y;
            aabArray[9 * i + 8] = triangle_b_box_centroid.z;

            totalWork[i] = i;
        }


        //console.time("BvhGeneration");
        //console.log("BvhGeneration...");

        // Build the BVH acceleration structure, which places a bounding box ('root' of the tree) around all of the
        // triangles of the entire mesh, then subdivides each box into 2 smaller boxes.  It continues until it reaches 1 triangle,
        // which it then designates as a 'leaf'
        const nAABs = BVH_Build_Iterative(totalWork, aabArray, aabArrayBuffer);

        //console.timeEnd("BvhGeneration");
      
        return {t: nTriangles, a: nAABs};
    }


    writeMeshBuffer(geo, triArray, aabArrayBuffer, triangleMaterialMarkers, pathTracingMaterialList, materialCache) {


        const nTriangles = geo.attributes.position.array.length / 9;
        const aabArray = new Float32Array(nTriangles * 9);
        const totalWork = new Uint32Array(nTriangles);

        const triangle_b_box_min = new THREE.Vector3();
        const triangle_b_box_max = new THREE.Vector3();
        const triangle_b_box_centroid = new THREE.Vector3();

        const modelHasUVs = (geo.attributes.uv !== undefined) ? true : false;

        const vpa = new Float32Array(geo.attributes.position.array);
        const vta = modelHasUVs ? new Float32Array(geo.attributes.uv.array) : null;

        let vp0 = new THREE.Vector3();
        let vp1 = new THREE.Vector3();
        let vp2 = new THREE.Vector3();
        let vt0 = new THREE.Vector2();
        let vt1 = new THREE.Vector2();
        let vt2 = new THREE.Vector2();

        for (let i = 0; i < nTriangles; i++) {
            let materialNumber = 0;

            triangle_b_box_min.set(Infinity, Infinity, Infinity);
            triangle_b_box_max.set(-Infinity, -Infinity, -Infinity);

            for (let j = 0; j < pathTracingMaterialList.length; j++) {
                if (i < triangleMaterialMarkers[j]) {
                    materialNumber = j;
                    break;
                }
            }

            // record vertex texture coordinates (UVs)
            if (modelHasUVs) {
                vt0.set(vta[6 * i + 0], vta[6 * i + 1]);
                vt1.set(vta[6 * i + 2], vta[6 * i + 3]);
                vt2.set(vta[6 * i + 4], vta[6 * i + 5]);
            }
            else {
                vt0.set(-1, -1);
                vt1.set(-1, -1);
                vt2.set(-1, -1);
            }

            // record vertex positions
            vp0.set(vpa[9 * i + 0], vpa[9 * i + 1], vpa[9 * i + 2]);
            vp1.set(vpa[9 * i + 3], vpa[9 * i + 4], vpa[9 * i + 5]);
            vp2.set(vpa[9 * i + 6], vpa[9 * i + 7], vpa[9 * i + 8]);

            //slot 0
            triArray[16 *i + 0] = vp0.x; // r or x
            triArray[16 *i + 1] = vp0.y; // g or y 
            triArray[16 *i + 2] = vp0.z; // b or z
            triArray[16 *i + 3] = vp1.x; // a or w

            //slot 1
            triArray[16 *i + 4] = vp1.y; // r or x
            triArray[16 *i + 5] = vp1.z; // g or y
            triArray[16 *i + 6] = vp2.x; // b or z
            triArray[16 *i + 7] = vp2.y; // a or w

            //slot 2
            triArray[16 *i + 8] = vp2.z; // r or x
            triArray[16 *i + 9] = materialCache[pathTracingMaterialList[materialNumber]].matId + materialCache[pathTracingMaterialList[materialNumber]].transparent * 100000 ; // g or y (& 0xFFFF)&(materialCache[pathTracingMaterialList[materialNumber]].transparent > 0 ? 0x10000 : 0x0000)
            triArray[16 *i + 10] = vt0.x; // b or z
            triArray[16 *i + 11] = vt0.y; // a or w

            //slot 3
            triArray[16 *i + 12] = vt1.x; // r or x
            triArray[16 *i + 13] = vt1.y; // g or y
            triArray[16 *i + 14] = vt2.x; // b or z
            triArray[16 *i + 15] = vt2.y; // a or w


            triangle_b_box_min.copy(triangle_b_box_min.min(vp0));
            triangle_b_box_max.copy(triangle_b_box_max.max(vp0));
            triangle_b_box_min.copy(triangle_b_box_min.min(vp1));
            triangle_b_box_max.copy(triangle_b_box_max.max(vp1));
            triangle_b_box_min.copy(triangle_b_box_min.min(vp2));
            triangle_b_box_max.copy(triangle_b_box_max.max(vp2));

            triangle_b_box_centroid.copy(triangle_b_box_min).add(triangle_b_box_max).multiplyScalar(0.5);

            aabArray[9 * i + 0] = triangle_b_box_min.x;
            aabArray[9 * i + 1] = triangle_b_box_min.y;
            aabArray[9 * i + 2] = triangle_b_box_min.z;
            aabArray[9 * i + 3] = triangle_b_box_max.x;
            aabArray[9 * i + 4] = triangle_b_box_max.y;
            aabArray[9 * i + 5] = triangle_b_box_max.z;
            aabArray[9 * i + 6] = triangle_b_box_centroid.x;
            aabArray[9 * i + 7] = triangle_b_box_centroid.y;
            aabArray[9 * i + 8] = triangle_b_box_centroid.z;

            totalWork[i] = i;
        }


        //console.time("BvhGeneration");
        //console.log("BvhGeneration...");

        // Build the BVH acceleration structure, which places a bounding box ('root' of the tree) around all of the
        // triangles of the entire mesh, then subdivides each box into 2 smaller boxes.  It continues until it reaches 1 triangle,
        // which it then designates as a 'leaf'
        const nAABs = BVH_Build_Iterative(totalWork, aabArray, aabArrayBuffer);

        //console.timeEnd("BvhGeneration");
      
        this.total_number_of_triangles += nTriangles;
        this.total_number_of_aabs += nAABs;

        //console.log(this.total_number_of_triangles + ' triangles ');
        //console.log(this.total_number_of_aabs + ' aabbs ' );

        return {t: nTriangles, a: nAABs};

    }

    writeMeshBufferIndexed(geo, triArray, indexArray, aabArrayBuffer, triangleMaterialMarkers, pathTracingMaterialList, materialCache) {

        const nTriangles = geo.index.count / 3;
        const nVertices = geo.attributes.position.count;
        const modelHasUVs = (geo.attributes.uv !== undefined) ? true : false;
   
        for (let i = 0; i < nVertices; i++) {
    
            //slot 0
            triArray[8 *i + 0] = geo.attributes.position.array[3 * i + 0]; // r or x
            triArray[8 *i + 1] = geo.attributes.position.array[3 * i + 1]; // r or x
            triArray[8 *i + 2] = geo.attributes.position.array[3 * i + 2]; // r or x

            if (modelHasUVs) {
                triArray[8 *i + 3] = geo.attributes.uv.array[2 * i + 0]; // a or w
                triArray[8 *i + 4] = geo.attributes.uv.array[2 * i + 1]; // a or w
            } else{
                triArray[8 *i + 3] = 0.0; // a or w
                triArray[8 *i + 4] = 0.0; // a or w
            }

            triArray[8 *i + 5] = geo.attributes.normal.array[3 * i + 0]; // r or x
            triArray[8 *i + 6] = geo.attributes.normal.array[3 * i + 1]; // r or x
            triArray[8 *i + 7] = geo.attributes.normal.array[3 * i + 2]; // r or x
        }


        const aabArray = new Float32Array(nTriangles * 9);
        const totalWork = new Uint32Array(nTriangles);

        const triangle_b_box_min = new THREE.Vector3();
        const triangle_b_box_max = new THREE.Vector3();
        const triangle_b_box_centroid = new THREE.Vector3();

        const vp0 = new THREE.Vector3();
        const vp1 = new THREE.Vector3();
        const vp2 = new THREE.Vector3();

        for (let i = 0; i < nTriangles; i++) {
            let materialNumber = 0;
       
            for (let j = 0; j < pathTracingMaterialList.length; j++) {
                if (i < triangleMaterialMarkers[j]) {
                    materialNumber = j;
                    break;
                }
            }

            const i1 = geo.index.array[i * 3 + 0];
            const i2 = geo.index.array[i * 3 + 1];
            const i3 = geo.index.array[i * 3 + 2];

            //slot 0
            indexArray[4 *i + 0] = i1; // r or x
            indexArray[4 *i + 1] = i2; // r or x
            indexArray[4 *i + 2] = i3; // r or x
            indexArray[4 *i + 3] = materialCache[pathTracingMaterialList[materialNumber]].matId; // r or x

            triangle_b_box_min.set(Infinity, Infinity, Infinity);
            triangle_b_box_max.set(-Infinity, -Infinity, -Infinity);
            // record vertex positions
            vp0.set(geo.attributes.position.array[i1 * 3 + 0], geo.attributes.position.array[i1 * 3 + 1], geo.attributes.position.array[i1 * 3 + 2]);
            vp1.set(geo.attributes.position.array[i2 * 3 + 0], geo.attributes.position.array[i2 * 3 + 1], geo.attributes.position.array[i2 * 3 + 2]);
            vp2.set(geo.attributes.position.array[i3 * 3 + 0], geo.attributes.position.array[i3 * 3 + 1], geo.attributes.position.array[i3 * 3 + 2]);

            triangle_b_box_min.copy(triangle_b_box_min.min(vp0));
            triangle_b_box_max.copy(triangle_b_box_max.max(vp0));
            triangle_b_box_min.copy(triangle_b_box_min.min(vp1));
            triangle_b_box_max.copy(triangle_b_box_max.max(vp1));
            triangle_b_box_min.copy(triangle_b_box_min.min(vp2));
            triangle_b_box_max.copy(triangle_b_box_max.max(vp2));

            triangle_b_box_centroid.copy(triangle_b_box_min).add(triangle_b_box_max).multiplyScalar(0.5);

            aabArray[9 * i + 0] = triangle_b_box_min.x;
            aabArray[9 * i + 1] = triangle_b_box_min.y;
            aabArray[9 * i + 2] = triangle_b_box_min.z;
            aabArray[9 * i + 3] = triangle_b_box_max.x;
            aabArray[9 * i + 4] = triangle_b_box_max.y;
            aabArray[9 * i + 5] = triangle_b_box_max.z;
            aabArray[9 * i + 6] = triangle_b_box_centroid.x;
            aabArray[9 * i + 7] = triangle_b_box_centroid.y;
            aabArray[9 * i + 8] = triangle_b_box_centroid.z;

            totalWork[i] = i;
        }


        //console.time("BvhGeneration");
        //console.log("BvhGeneration...");

        // Build the BVH acceleration structure, which places a bounding box ('root' of the tree) around all of the
        // triangles of the entire mesh, then subdivides each box into 2 smaller boxes.  It continues until it reaches 1 triangle,
        // which it then designates as a 'leaf'
        const nAABs = BVH_Build_Iterative(totalWork, aabArray, aabArrayBuffer);

        //console.timeEnd("BvhGeneration");
      
        this.total_number_of_triangles += nTriangles;
        this.total_number_of_aabs += nAABs;

        //console.log(this.total_number_of_triangles + ' triangles ');
        //console.log(this.total_number_of_aabs + ' aabbs ' );

        return {i: nTriangles, v: nVertices, a: nAABs};

    }

    writeParticleMeshBuffer(geo, nParticles, triArray, aabArrayBuffer, matBuffer, triangleMaterialMarkers, pathTracingMaterialList, matOffset, transform) {

        for (let j = 0; j < pathTracingMaterialList.length; j++) {
            //slot 0
            matBuffer[j * 16 + 0] = pathTracingMaterialList[j].type; // r or x 
            matBuffer[j * 16 + 1] = pathTracingMaterialList[j].color.r; // g or y
            matBuffer[j * 16 + 2] = pathTracingMaterialList[j].color.g; // b or z
            matBuffer[j * 16 + 3] = pathTracingMaterialList[j].color.b; // a or w
  
            //slot 1
            matBuffer[j * 16 + 4] = pathTracingMaterialList[j].albedoTextureID; // r or x
            matBuffer[j * 16 + 5] = pathTracingMaterialList[j].normalTextureID; // g or y
            matBuffer[j * 16 + 6] = pathTracingMaterialList[j].roughness; // b or z
            matBuffer[j * 16 + 7] = pathTracingMaterialList[j].emissive.r; // a or w
  
            //slot 2
            matBuffer[j * 16 + 8] = pathTracingMaterialList[j].emissive.g; // r or x
            matBuffer[j * 16 + 9] = pathTracingMaterialList[j].emissive.b; // g or y
            matBuffer[j * 16 + 10] = pathTracingMaterialList[j].ior; // b or z
            matBuffer[j * 16 + 11] = pathTracingMaterialList[j].metalness; // a or w	
            
            matBuffer[j * 16 + 12] = 0.0; // a or w	
            matBuffer[j * 16 + 13] = 0.0; // a or w	
            matBuffer[j * 16 + 14] = 0.0; // a or w	
            matBuffer[j * 16 + 15] = 1.0; // a or w	
        }

        const nTriangles = nParticles * 2;
        const aabArray = new Float32Array(nTriangles * 9);
        const totalWork = new Uint32Array(nTriangles);

        const triangle_b_box_min = new THREE.Vector3();
        const triangle_b_box_max = new THREE.Vector3();
        const triangle_b_box_centroid = new THREE.Vector3();

        const vpa = new Float32Array(geo.attributes.position.array);

        let p = new THREE.Vector3();
        let vp0 = new THREE.Vector3();
        let vp1 = new THREE.Vector3();
        let vp2 = new THREE.Vector3();
      
        let vt0 = new THREE.Vector2();
        let vt1 = new THREE.Vector2();
        let vt2 = new THREE.Vector2();

        const bt = new Transformation3();

        const particlesPts = [new THREE.Vector3(),new THREE.Vector3(),new THREE.Vector3(),new THREE.Vector3()];

        const particlesUv= [{u:0,v:0},{u:0, v:1},{u:1,v:0},{u:1,v:1}];
        const particlesIdxs=[2,1,0,3,1,2];
        const norm = new THREE.Vector3();

        for (let i = 0; i < nParticles; i++) {

            const s = geo.attributes.customSize ? geo.attributes.customSize.array[i + 0] : 1.0;
            const v = geo.attributes.customVisible ? geo.attributes.customVisible.array[i + 0] : 1.0;

            particlesPts[0].set(-0.5 * s, -0.5 * s,0);
            particlesPts[1].set(-0.5 * s, +0.5 * s,0);
            particlesPts[2].set(+0.5 * s, -0.5 * s,0);
            particlesPts[3].set(+0.5 * s, +0.5 * s,0);

            norm.set(vpa[3 * i + 0] - transform.position.x, vpa[3 * i + 1] - transform.position.y, vpa[3 * i + 2] - transform.position.z),
            norm.normalize();
           
            /* particle position */
            p.set(vpa[3 * i + 0], vpa[3 * i + 1], vpa[3 * i + 2]);
            bt.set(p);
            bt.lookAt(transform.position);
 
            for(let k =0;k<2;k++) {

                const triIdx = i * 2 + k;

                const p1 = bt.applyV(particlesPts[particlesIdxs[k * 3 + 0]]);
                const p2 = bt.applyV(particlesPts[particlesIdxs[k * 3 + 1]]);
                const p3 = bt.applyV(particlesPts[particlesIdxs[k * 3 + 2]]);
                           
                vt0.set(particlesUv[particlesIdxs[k * 3 + 0]].u, particlesUv[particlesIdxs[k * 3 + 0]].v);
                vt1.set(particlesUv[particlesIdxs[k * 3 + 1]].u, particlesUv[particlesIdxs[k * 3 + 1]].v);
                vt2.set(particlesUv[particlesIdxs[k * 3 + 2]].u, particlesUv[particlesIdxs[k * 3 + 2]].v);

                let materialNumber = 0;

                triangle_b_box_min.set(Infinity, Infinity, Infinity);
                triangle_b_box_max.set(-Infinity, -Infinity, -Infinity);
    
                for (let j = 0; j < pathTracingMaterialList.length; j++) {
                    if (triIdx < triangleMaterialMarkers[j]) {
                        materialNumber = j;
                        break;
                    }
                }
                
                // record vertex positions
                vp0.set(p1.x, p1.y, p1.z);
                vp1.set(p2.x, p2.y, p2.z);
                vp2.set(p3.x, p3.y, p3.z);
                
                //slot 0
                triArray[36 * triIdx + 0] = vp0.x; // r or x
                triArray[36 * triIdx + 1] = vp0.y; // g or y 
                triArray[36 * triIdx + 2] = vp0.z; // b or z
                triArray[36 * triIdx + 3] = vp1.x; // a or w
                
                //slot 1
                triArray[36 * triIdx + 4] = vp1.y; // r or x
                triArray[36 * triIdx + 5] = vp1.z; // g or y
                triArray[36 * triIdx + 6] = vp2.x; // b or z
                triArray[36 * triIdx + 7] = vp2.y; // a or w
                

                const matid = (((materialNumber + matOffset) & 0xFFFF) | (pathTracingMaterialList[materialNumber].albedoTextureID<<16))

                //slot 2
                triArray[36 *triIdx + 8] = vp2.z; // r or x
                triArray[36 *triIdx + 9] = pathTracingMaterialList[materialNumber].transparent; // g or y
                triArray[36 *triIdx + 10] = v; // b or z
                triArray[36 *triIdx + 11] = matid; // a or w

                //slot 3
                triArray[36 * triIdx + 12] = vt0.x; // r or x
                triArray[36 * triIdx + 13] = vt0.y; // g or y
                triArray[36 * triIdx + 14] = vt1.x; // b or z
                triArray[36 * triIdx + 15] = vt1.y; // a or w
                
                //slot 4
                triArray[36 * triIdx + 16] = vt2.x; // r or x
                triArray[36 * triIdx + 17] = vt2.y; // g or y
                triArray[36 * triIdx + 18] = norm.x; // b or z
                triArray[36 * triIdx + 19] = norm.y; // a or w
    
                //slot 5
                triArray[36 * triIdx + 20] = norm.z; // r or x
                triArray[36 * triIdx + 21] = norm.x; // g or y
                triArray[36 * triIdx + 22] = norm.y; // b or z
                triArray[36 * triIdx + 23] = norm.z; // a or w
                
                // the remaining slots are used for PBR material properties
                //slot 6
                triArray[36 * triIdx + 24] = norm.x; // r or x 
                triArray[36 * triIdx + 25] = norm.y; // g or y
                triArray[36 * triIdx + 26] = norm.z; // b or z
                triArray[36 * triIdx + 27] = 0.0; // a or w
                
                //slot 7
                triArray[36 * triIdx + 28] = 0.0; // r or x
                triArray[36 * triIdx + 29] = 0.0; // g or y
                triArray[36 * triIdx + 30] = 0.0; // b or z
                triArray[36 * triIdx + 31] = 0.0; // a or w
                
                //slot 8
                triArray[36 * triIdx + 32] = 0.0; // r or x
                triArray[36 * triIdx + 33] = 0.0; // g or y
                triArray[36 * triIdx + 34] = 0.0; // b or z
                triArray[36 * triIdx + 35] = 0.0; // a or w			
                
                triangle_b_box_min.copy(triangle_b_box_min.min(vp0));
                triangle_b_box_max.copy(triangle_b_box_max.max(vp0));
                triangle_b_box_min.copy(triangle_b_box_min.min(vp1));
                triangle_b_box_max.copy(triangle_b_box_max.max(vp1));
                triangle_b_box_min.copy(triangle_b_box_min.min(vp2));
                triangle_b_box_max.copy(triangle_b_box_max.max(vp2));
                
                triangle_b_box_centroid.copy(triangle_b_box_min).add(triangle_b_box_max).multiplyScalar(0.5);
                
                aabArray[9 * triIdx + 0] = triangle_b_box_min.x;
                aabArray[9 * triIdx + 1] = triangle_b_box_min.y;
                aabArray[9 * triIdx + 2] = triangle_b_box_min.z;
                aabArray[9 * triIdx + 3] = triangle_b_box_max.x;
                aabArray[9 * triIdx + 4] = triangle_b_box_max.y;
                aabArray[9 * triIdx + 5] = triangle_b_box_max.z;
                aabArray[9 * triIdx + 6] = triangle_b_box_centroid.x;
                aabArray[9 * triIdx + 7] = triangle_b_box_centroid.y;
                aabArray[9 * triIdx + 8] = triangle_b_box_centroid.z;
                
                totalWork[triIdx] = triIdx;
            }
        }


        //console.time("BvhGeneration");
        //console.log("BvhGeneration...");

        // Build the BVH acceleration structure, which places a bounding box ('root' of the tree) around all of the
        // triangles of the entire mesh, then subdivides each box into 2 smaller boxes.  It continues until it reaches 1 triangle,
        // which it then designates as a 'leaf'
        const nAABs = BVH_Build_Iterative(totalWork, aabArray, aabArrayBuffer);

        //console.timeEnd("BvhGeneration");
      
        this.total_number_of_triangles += nTriangles;
        this.total_number_of_aabs += nAABs;

        //console.log(this.total_number_of_triangles + ' triangles ');
        //console.log(this.total_number_of_aabs + ' aabbs ' );

        return {t: nTriangles, a: nAABs};

    }
}




function noFilter(){ return true; }

function filterNoTree(child, imat){

    if(imat.name.startsWith('Toon-twig_bark'))
        return false;

    if(imat.name.startsWith('Toon-leaf'))
        return false;

    if(imat.name.startsWith('tritun'))
        return true;

    
    if((imat.emissive.r < 0.1)&&(imat.emissive.g < 0.1)&&(imat.emissive.b< 0.1))
        return false;
        

    return true;

}

function filterEmmissive(child, imat){

    if(!imat.emissive)
        return false;

    if((imat.emissive.r < 0.2)&&(imat.emissive.g < 0.2)&&(imat.emissive.b < 0.2))
        return false;

    return true;

}

class RTEngine {

    constructor(renderer){
        this.fogDensity = 0;
        
        this.matrix_array = new Float32Array(lineWith * 16 * 4);
        
        this.alwaysRender = [];

        this.recyledMatIds = [];
        this.recyledGeoIds = [];

        this.nGeometries = 0;
        this.numSpheres = 0;
        this.numCubes = 0;
        this.numCylinders = 0;
        this.numMaterials = 0;
        this.particlesId = 1;
        this.lastTexId = 0;
        this.meshInstances = [];
        this.meshNames = [];
        this.meshPos = [];
        this.particles = [];
        
        this.hiddenObjects = [];
        this.shadowSrc = {};
        this.SkyBox = {};
        this.uniqueMaterialTextures = [];
        this.texs = [];
        this.materialCache = [];
         this.BigTextures = [];
        this.areas = [];

        const image = new Image(256, 256);
        this.skyTexture = new THREE.Texture(image);
        this.it = new Transformation3();
        this.renderer = renderer;
        this.resetTex();
    }

    findGeos(mesh, dist = 300){

        const pos = mesh.position;
        mesh.rtGeos = []

        for(let g=0; g< this.nGeometries; g++){

            if(pos.distanceTo(this.meshPos[g])<dist)
                mesh.rtGeos.push(g);
        }

        mesh.uNumGeometries = mesh.rtGeos.length;

        const idx = FIRST_GEOLIST + mesh.uGeoIndex * 4;
        for(let n=0;n<mesh.uNumGeometries;n++){
            this.matrix_array[idx + n] = mesh.rtGeos[n];
        }
    }

    findArea(pos){

        for(let area of this.areas){
            if(area.box.containsPoint(pos)){
                return area;
            }
        }
        return null;
    }

    buildAreas(exclude){

        const pt = new THREE.Vector3();
        for(let area of this.areas){

            for(let g=0; g< this.nGeometries; g++){

                if(exclude.indexOf(g)>=0)
                    continue;

                const idx = g * 16;

                pt.x = this.meshPos[g].x;
                pt.y = this.meshPos[g].y;
                pt.z = this.meshPos[g].z;

                if(area.box.containsPoint(pt)){
                    area.geos.push(g);
                }
            }
        }
        //console.log('areas : ',this.areas);
    }


    buildMesh(mesh){

        const geo = mesh.geometry;
        mesh.updateMatrix();
        const pt = new THREE.Vector3();
        const polyUsed = new Uint8Array(geo.index.count / 3);

        for(let area of this.areas){
            
            let nTris = 0;

            const newGeo = geo.clone();
            newGeo.applyMatrix4(mesh.matrix);
                       
            for(let v=0;v<geo.index.count;v+=3){

                if(polyUsed[v/3] == 1)
                    continue;

                const i1 = geo.index.array[v + 0];
                const i2 = geo.index.array[v + 1];
                const i3 = geo.index.array[v + 2];

                pt.set(newGeo.attributes.position.array[i1 * 3 + 0], newGeo.attributes.position.array[i1 * 3 + 1], newGeo.attributes.position.array[i1 * 3 + 2]);
                if(area.box.containsPoint(pt)){
                    nTris++;
                    continue;
                }

                pt.set(newGeo.attributes.position.array[i2 * 3 + 0], newGeo.attributes.position.array[i2 * 3 + 1], newGeo.attributes.position.array[i2 * 3 + 2]);
                if(area.box.containsPoint(pt)){
                    nTris++;
                    continue;
                }

                pt.set(newGeo.attributes.position.array[i3 * 3 + 0], newGeo.attributes.position.array[i3 * 3 + 1], newGeo.attributes.position.array[i3 * 3 + 2]);
                if(area.box.containsPoint(pt)){
                    nTris++;
                    continue;
                }
            }

            const newIndexes = new Uint16Array(nTris * 3);
            nTris = 0;
            const newMats = [];
            for(let mi =0;mi<mesh.material.length;mi++) {
                const nm = new THREE.MeshRTPhysicalMaterial({envMapIntensity : 0.2});
                nm.copy(mesh.material[mi]);
                nm.envMapIntensity = 0.2;
                newMats[mi] = nm;
            }

            for(let g=0;g<geo.groups.length;g++) {

                newGeo.groups[g].start = nTris;

                for(let v= geo.groups[g].start; v<  geo.groups[g].start +  geo.groups[g].count; v+=3){
                    
                    if(polyUsed[v/3] == 1)
                        continue;

                    const i1 = geo.index.array[v + 0];
                    const i2 = geo.index.array[v + 1];
                    const i3 = geo.index.array[v + 2];

                    pt.set(newGeo.attributes.position.array[i1 * 3 + 0], newGeo.attributes.position.array[i1 * 3 + 1], newGeo.attributes.position.array[i1 * 3 + 2]);
                    if(area.box.containsPoint(pt)) {
                        newIndexes[(nTris++)] = i1;
                        newIndexes[(nTris++)] = i2;
                        newIndexes[(nTris++)] = i3;
                        polyUsed[v/3] = 1;
                        continue;
                    }

                    pt.set(newGeo.attributes.position.array[i2 * 3 + 0], newGeo.attributes.position.array[i2* 3 + 1], newGeo.attributes.position.array[i2 * 3 + 2]);
                    if(area.box.containsPoint(pt)) {
                        newIndexes[(nTris++)] = i1;
                        newIndexes[(nTris++)] = i2;
                        newIndexes[(nTris++)] = i3;
                        polyUsed[v/3] = 1;
                        continue;
                    }

                    pt.set(newGeo.attributes.position.array[i3 * 3 + 0], newGeo.attributes.position.array[i3 * 3 + 1], newGeo.attributes.position.array[i3 * 3 + 2]);
                    if(area.box.containsPoint(pt)) {
                        newIndexes[nTris++] = i1;
                        newIndexes[nTris++] = i2;
                        newIndexes[nTris++] = i3;
                        polyUsed[v/3] = 1;
                        continue;
                    }
                }
                newGeo.groups[g].count = nTris - newGeo.groups[g].start;
            }

            newGeo.setIndex(new Uint16BufferAttribute(newIndexes, 1));

            newGeo.computeBoundingBox();
            newGeo.boundingBox.getCenter(pt);
            newGeo.translate(-pt.x, -pt.y, -pt.z);

            newGeo.computeBoundingBox();
            newGeo.computeBoundingSphere();
            newGeo.computeBoundsTree();

            area.mesh =  new THREE.Mesh(newGeo,  newMats)
            area.mesh.name = 'area '+area.name;
            area.mesh.position.set(pt.x, pt.y, pt.z);
            area.mesh.frustumCulled = true;
            area.mesh.renderOrder = 16000;

            this.enableRT(area.mesh, area.geos);
        }
        //console.log('areas ',this.areas);
    }

    
    
    setTextureOffset(m, name, offsetx = null, offsety = null, sizex = null, sizey = null){

        const mesh = m.rtMesh ? m.rtMesh: m;

        if(!mesh.materials)
            return;

        for(let matname of mesh.materials){

            const mat = this.materialCache[matname];
            if(!mat)
                continue;

            if((name === null)||(mat.name.startsWith(name))){

                //const materialArray = this.matrix_array.subarray(FIRST_MAT + mat.matId * 16, FIRST_MAT + (mat.matId + 1) * 16);

                const idx = FIRST_MAT + mat.matId * 16;

                if(offsetx !== null)
                    this.matrix_array[idx+14] = offsetx; // g or y

                if(offsety !== null)
                    this.matrix_array[idx+15] = offsety; // b or z
                

                /*
                if(sizex !== null)
                    this.matrix_array[idx+15] = sizex; // b or z
                */

                return;
            }
        }

    }

    setTex(m, name, tex){ 
        const mesh = m.rtMesh ? m.rtMesh: m;

        if(!mesh.geometry)
            return;

        if(!mesh.materials)
            return;

        if(m.material.length <= 0)
            return;

        for(let omat of m.material){

            if((name !== null)&&(omat.name !== name))
                continue;

            omat.map = tex;

            const otex = omat.map;

            for(let matname of mesh.materials){

                const mat = this.materialCache[matname];

                if((name === null)||(mat.name === name)){

                    if(mat.albedoTextureID>=0){

                        const uvVecx = this.matrix_array[FIRST_TEXCOORD + mat.albedoTextureID * 4 + 0];
                        const uvVecy = this.matrix_array[FIRST_TEXCOORD + mat.albedoTextureID * 4 + 1];

                        const texId = this.matrix_array[FIRST_TEXID + mat.albedoTextureID * 4]; //this.uniqueMaterialTexturesTids
                        const btex = this.BigTextures[texId];
                        const tex = btex.tex;
                        const texPos = new THREE.Vector2(uvVecx * btex.maxSize, uvVecy * btex.maxSize);

                        this.renderer.copyTextureToTexture(texPos, otex, tex, 0);
                        tex.needsUpdate = true;
                    }
                    return;
                }
            }
        }
    }

    updateETex(m, name){ }

    updateTex(m, name){

        const mesh = m.rtMesh ? m.rtMesh: m;

        if(!mesh.geometry)
            return;

        if(m.material.length <= 0)
            return;

        for(let omat of m.material){

            if((name !== null)&&(omat.name !== name))
                continue;

            const otex = omat.map;

            if((otex === null)||(!otex.isCanvas))
                continue;

            for(let mat of mesh.materials){

                if((name === null)||(mat.name === name)){

                    if(mat.albedoTextureID>=0){

                        const uvVecx = this.matrix_array[FIRST_TEXCOORD + mat.albedoTextureID*4+0];
                        const uvVecy = this.matrix_array[FIRST_TEXCOORD + mat.albedoTextureID*4+1];
                        const texId = this.matrix_array[FIRST_TEXID +mat.albedoTextureID * 4];
                        const btex = this.BigTextures[texId];
                        const tex = btex.tex;
                        const texPos = new THREE.Vector2(uvVecx * btex.maxSize, uvVecy * btex.maxSize);

                        this.renderer.copyTextureToTexture(texPos, otex, tex, 0);
                        tex.needsUpdate = true;
                    }
                    return;
                }
            }
        }
    }

    setEmission(m, name, r, g, b, i = null){ 

        const mesh = m.rtMesh ? m.rtMesh: m;

        if(!mesh.materials)
            return;

        for(let matname of mesh.materials){

            const mat = this.materialCache[matname];

            if((name === null)||(mat.name === name)){

                if(r !== null)
                    mat.emissive.r = r;

                if(g !== null)
                    mat.emissive.g = g;
                
                if(b !== null)
                    mat.emissive.b = b;

                const idx = FIRST_MAT + mat.matId * 16;

                this.matrix_array[idx+7] = mat.emissive.r;
                this.matrix_array[idx+8] = mat.emissive.g;
                this.matrix_array[idx+9] = mat.emissive.b;

                return;
            }
        }
    }

    setEnvMap(map){
        this.skyTexture = map;
    }

    resetTex(){
        
        this.uniqueMaterialTextures = [];
        //this.uniqueMaterialTexturesTids = new Array(256);

        this.numMaterials = 0;
        this.lastTexId = 0;

        let t = null;
        while((t = this.BigTextures.pop())){
            t.tex.dispose();
        }

        this.lastBigTexture = new bigTex(this.renderer);
        this.BigTextures = [this.lastBigTexture];
    }

    resetMesh(){
        
        this.triangeBuffer.reset();
        this.aabbBuffer.reset();
        this.meshCollision = new MeshCollision();
    }

    resetSpheres(){
        this.numSpheres = 0;

        this.drawMesh(this.SkyBox.meshGPU);
        
        for(let m of this.rtMeshes){
            m.uNumSpheres= this.numSpheres;
            m.uNumGeometries= m.rtGeos.length;
        }
    }

    initScene() {
        
        this.nGeometries = 0;
        this.numSpheres = 0;
        this.numCylinders = 0;
        this.numCubes = 0;
        this.numLights = 0;
        this.numMaterials = 0;
        this.lastTexId = 1;
        this.lastGeoList = 0;

        this.rtMeshes = [];
        this.areas = [];

        this.recyledGeoIds = [];
        this.materialCache = [];

        this.alwaysRender = [];
        
        this.meshNames = [];
        this.meshPos = [];

        this.uniqueMaterialTextures = [];

        this.matrix_array.fill(0, 0, this.matrix_array.length);
        this.MatrixDataTexture.needsUpdate = true;
      
    }

    reset(){

        let mesh = null;
        while((mesh = this.rtMeshes.pop())){
            mesh.uNumSpheres = 0;
            mesh.uNumGeometries = 0;
            mesh.rtGeos = [];
            mesh.uGeoIndex = -1;
        }

        let area = null;
        while((area = this.areas.pop())){
            area.mesh.geometry.dispose();
        }

        this.resetMesh();
        this.resetTex();
        this.initScene();
    }

    async initRT(){

        initShaders();
  
        this.pathTracingFragmentShader = shader;
        THREE.ShaderChunk[ 'pathtracing_main' ] = this.pathTracingFragmentShader;

        this.EPS_intersect = 0.001;

        const lineStride = lineSize * 4;

        this.triangeBuffer = new BufferAllocator(lineWith, lineStride, 2);
        this.aabbBuffer = new BufferAllocator(lineWith, lineStride, 2);
        this.meshCollision = new MeshCollision(lineWith);

        this.MatrixDataTexture = new THREE.DataTexture(this.matrix_array,
            lineWith,
            16,
            THREE.RGBAFormat,
            THREE.FloatType,
            THREE.Texture.DEFAULT_MAPPING,
            THREE.ClampToEdgeWrapping,
            THREE.ClampToEdgeWrapping,
            THREE.NearestFilter,
            THREE.NearestFilter,
            1,
            THREE.NoColorSpace);

        this.MatrixDataTexture.encoding = THREE.LinearEncoding;
        this.MatrixDataTexture.flipY = false;
        this.MatrixDataTexture.generateMipmaps = false;
        this.MatrixDataTexture.needsUpdate = true;

        this.lastBigTexture = new bigTex(this.renderer);
        this.BigTextures = [this.lastBigTexture];

        this.initScene();

        /*
        const texLoader = new THREE.TextureLoader();
        const ntex = await texLoader.load(this.assetBase+'/assets/textures/BlueNoise_RGBA256.png');

        ntex.wrapS = THREE.RepeatWrapping;
        ntex.wrapT = THREE.RepeatWrapping;
        ntex.flipY = false;
        ntex.minFilter = THREE.NearestFilter;
        ntex.magFilter = THREE.NearestFilter;
        ntex.generateMipmaps = false;

        this.blueNoiseTexture = ntex;

        const texture = await texLoader.load(this.assetBase+'/assets/textures/darkWood.jpg');
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.flipY = false;
        texture.minFilter = THREE.NearestFilter;
        texture.magFilter = THREE.NearestFilter;
        texture.generateMipmaps = false;
        this.darkWoodTexture = texture;
            */
      
        this.isIndexed = false;
        
        this.addSphere(this.SkyBox, 10000.0, new THREE.Vector3(0, 0, 0), new THREE.Vector3(0.5, 0.5, 0.8), new THREE.Vector3(0.5, 0.5, 0.8), 0.1, RT_SKYBOX); 
        
        
    }

    enableRT(mesh, geos= null){

        mesh.tTriangleTexture = this.triangeBuffer.buffer ;
        mesh.tAABBTexture = this.aabbBuffer.buffer ;
        mesh.tMatrixTexture = this.MatrixDataTexture ;
        mesh.tAlbedoTexture= this.BigTextures[0].tex;
        mesh.uNumSpheres = this.numSpheres;
     
        mesh.rtGeos = [];
        mesh.uGeoIndex = this.lastGeoList * 64;
        this.lastGeoList++

        if(geos){
            mesh.uNumGeometries = geos.length; //this.nGeometries;

            for(let i =0;i<geos.length;i++){
                mesh.rtGeos[i] =  geos[i];
            }
        }else{

            let nGeos = 0;
            for(let i =0;i<this.nGeometries;i++){

                if(this.recyledGeoIds.indexOf(i)<0)
                    mesh.rtGeos[nGeos++] =  i;
            }
            mesh.uNumGeometries = nGeos;
        }

        if( (mesh.rtMesh)&&
            (mesh.name!=='Plane')&&
            (!mesh.name.startsWith('area')))
        {
            mesh.uIgnoreGeoID = mesh.rtMesh.geoID;
        }

        this.rtMeshes.push(mesh);
    }





    disableAllRT(){

        for(let mesh of this.rtMeshes) {

            if(mesh.material.length) {

                for(let mi =0; mi<mesh.material.length; mi++) {
                    mesh.material[mi] = new THREE.MeshPhysicalMaterial({envMapIntensity : 1.0}).copy(mesh.material[mi]);;
                }
            }else{
                mesh.material = new THREE.MeshPhysicalMaterial({envMapIntensity : 1.0}).copy(mesh.material);
            }

            mesh.uNumGeometries = 0;
            mesh.uGeoIndex = -1;
            mesh.uNumSpheres = 0;
            mesh.tTriangleTexture = null;
            mesh.tAABBTexture = null;
            mesh.tMatrixTexture = null;
            mesh.tAlbedoTexture= null;

        }

        this.resetTex();
        this.resetMesh();
        this.initScene();

    }



    removeMesh(m, removeMats = true) {

        if (!m)
            return;

        if (!m.geometry)
            return;     
        
       
        const rid = this.alwaysRender.indexOf(m.geoID);
        if(rid>=0)
            this.alwaysRender.splice(rid, 1);
        
        for (let mi=0;mi<this.rtMeshes.length;mi++){

            const gid = this.rtMeshes[mi].rtGeos.indexOf(m.geoID);
            if(gid>=0){
                this.rtMeshes[mi].rtGeos.splice(gid, 1);
                this.rtMeshes[mi].uNumGeometries--;

                /*
                const idx = FIRST_GEOLIST +  this.rtMeshes[mi].uGeoIndex * 4;
                for(let n=0;n< this.rtMeshes[mi].uNumGeometries;n++){
                    this.matrix_array[idx + n] =  this.rtMeshes[mi].rtGeos[n]
                } 
                */               
            }
        }
        

        if(m.geometry.triangles.r)
            this.triangeBuffer.unrefRange(m.geometry.triangles.r);

        if(m.geometry.aabbs.r)
            this.aabbBuffer.unrefRange(m.geometry.aabbs.r);

        console.log('removeMesh '+m.name+' '+ m.geoID+' ',m.geometry.triangles.r);

        this.meshCollision.total_number_of_triangles -= m.geometry.triangles.n;
        this.meshCollision.total_number_of_aabs -= m.geometry.aabbs.n;

        m.geometry.triangles.r = null;
        m.geometry.aabbs.r = null;

        this.recyledGeoIds.push(m.geoID);
        console.log('recyledGeoIds ',this.recyledGeoIds);
    
        if(!removeMats)
            return;

        for(let mat of m.materials){
            this.recyledMatIds.push(mat.matId);
        }
        
    }

    
    updateMesh(geo, pMesh, dt, copyEncoder) {


        const curTris = geo.index ? geo.index.count / 3 : geo.attributes.position.array.length / 9;
        this.aabbBuffer.initializeStagingBuffer(curTris * 8 * 4 , copyEncoder);
        const aabArrayBuffer = this.aabbBuffer.getStagingRange(0);

        this.triangeBuffer.initializeStagingBuffer(curTris * 4 * 4, copyEncoder);
        const triArray = this.triangeBuffer.getStagingRange(curTris * 4 * 4);
        
        this.meshCollision.writeMeshBuffer(geo,  triArray, aabArrayBuffer, triangleMaterialMarkers, pathTracingMaterialList, this.materialCache);

        this.triangeBuffer.commitStagingRange(pMesh.geometry.triangles.r, pMesh.geometry.triangles.t * 4);
        this.aabbBuffer.commitStagingRange(pMesh.geometry.aabbs.r, pMesh.geometry.aabbs.a * 8);
    }

    
    updateSkinnedMesh(mesh, copyEncoder){

        const geo = mesh.geometry;
        const curTris = geo.index ? geo.index.count / 3 : geo.attributes.position.array.length / 9;

        this.aabbBuffer.initializeStagingBuffer(curTris * 8 * 4 , copyEncoder);
        const aabArrayBuffer = this.aabbBuffer.getStagingRange(0);

        this.triangeBuffer.initializeStagingBuffer(curTris * 4 * 4, copyEncoder);
        const triArray = this.triangeBuffer.getStagingRange(curTris * 4 * 4);

        const triangleMaterialMarkers = [];
        const pathTracingMaterialList = [];

        let numTriangles=0;

        for(let grp of mesh.geometry.groups){

            numTriangles += grp.count / 3;
            triangleMaterialMarkers[grp.materialIndex] = numTriangles;
            pathTracingMaterialList.push(mesh.material[grp.materialIndex].name);
        }
            
        const infos = this.meshCollision.updateSkinnedMeshBuffer(mesh,  triArray, aabArrayBuffer, triangleMaterialMarkers, pathTracingMaterialList, this.materialCache);

        this.triangeBuffer.commitStagingRange(mesh.rtMesh.geometry.triangles.r, mesh.rtMesh.geometry.triangles.n * 4);
        this.aabbBuffer.commitStagingRange(mesh.rtMesh.geometry.aabbs.r, mesh.rtMesh.geometry.aabbs.n * 8);
    }


    addRTData(geo, transformation, triangleMaterialMarkers, pathTracingMaterialList, name = null) {
        if (!geo)
            return;

        if (!geo.attributes)
            return;

        if((FIRST_MAT + (this.numMaterials + pathTracingMaterialList.length) * 16)>=this.matrix_array.length){
            console.warn('material buffer full');
            return;
        }

        const matBuffer = this.matrix_array.subarray(FIRST_MAT, FIRST_MAT + (this.numMaterials + pathTracingMaterialList.length)  * 16);
        for (let j = 0; j < pathTracingMaterialList.length; j++) {
            const srcMat = this.materialCache[pathTracingMaterialList[j]];

            if(srcMat.matId<0){

                //slot 0
                matBuffer[this.numMaterials * 16 + 0] = srcMat.type; // r or x 
                matBuffer[this.numMaterials * 16 + 1] = srcMat.color.r; // g or y
                matBuffer[this.numMaterials * 16 + 2] = srcMat.color.g; // b or z
                matBuffer[this.numMaterials * 16 + 3] = srcMat.color.b; // a or w
    
                //slot 1
                matBuffer[this.numMaterials * 16 + 4] = srcMat.albedoTextureID; // r or x
                matBuffer[this.numMaterials * 16 + 5] = srcMat.emissiveTextureID; // g or y
                matBuffer[this.numMaterials * 16 + 6] = srcMat.roughness; // b or z
                matBuffer[this.numMaterials * 16 + 7] = srcMat.emissive.r; // a or w
    
                //slot 2
                matBuffer[this.numMaterials * 16 + 8] = srcMat.emissive.g; // r or x
                matBuffer[this.numMaterials * 16 + 9] = srcMat.emissive.b; // g or y
                matBuffer[this.numMaterials * 16 + 10] = srcMat.ior; // b or z
                matBuffer[this.numMaterials * 16 + 11] = srcMat.metalness; // a or w		

                //slot 3
                matBuffer[this.numMaterials * 16 + 12] = srcMat.emissiveIntensity; // a or w	
                matBuffer[this.numMaterials * 16 + 13] = srcMat.alphaTextureID; // a or w	
                matBuffer[this.numMaterials * 16 + 14] = 0.0; // a or w	
                matBuffer[this.numMaterials * 16 + 15] = 0.0; // a or w	

                srcMat.matId = this.numMaterials;
                this.numMaterials++;
            }
        }

        /*
        const isRecyled = this.recyledMatIds.length > 0 ? true : false;
        const matIDX = isRecyled ? this.recyledMatIds.pop() : this.numMaterials;
        const materialArray = this.matrix_array.subarray(FIRST_MAT + matIDX * 16, FIRST_MAT + (matIDX + pathTracingMaterialList.length) * 16);
       
       
        if(!isRecyled)
            this.numMaterials += pathTracingMaterialList.length;
        */
        
        const curTris = geo.index ? geo.index.count / 3 : geo.attributes.position.array.length / 9;
        this.aabbBuffer.initializeStagingBuffer(curTris * 8 * 4 , this.renderer);
        const aabArrayBuffer = this.aabbBuffer.getStagingRange(0);

        let infos, geometry;

        if(geo.index){

            const curVtx =  geo.attributes.position.count;
            this.triangeBuffer.initializeStagingBuffer(curVtx * 2 * 4 + curTris * 4, this.renderer);

            const indexArray = this.triangeBuffer.getStagingRange(curTris * 4);
            const triArray = this.triangeBuffer.getStagingRange(curVtx * 2 * 4);
                        
            infos = this.meshCollision.writeMeshBufferIndexed(geo,  triArray, indexArray, aabArrayBuffer,  triangleMaterialMarkers, pathTracingMaterialList, this.materialCache);

            const indexRange = this.triangeBuffer.getBufferRange(infos.i * 4, name);
            this.triangeBuffer.commitStagingRange(indexRange, infos.i);

            const verticesRange = this.triangeBuffer.getBufferRange(infos.v * 2 * 4, name);
            this.triangeBuffer.commitStagingRange(verticesRange, infos.v * 2);

            geometry = {transformation: transformation ,vertices: {n: infos.v, r: verticesRange}, triangles: {n: infos.i, r: indexRange}};

            //console.log('addRTData indexed '+ infos.i + ' ' + indexRange.start + '-' + indexRange.end +' vertices '+ infos.v + ' ' + verticesRange.start + '-' + verticesRange.end + ' aabbRange ' + infos.a + ' materials ' + this.numMaterials);
        }else{
            this.triangeBuffer.initializeStagingBuffer(curTris * 4 * 4, this.renderer);
            const triArray = this.triangeBuffer.getStagingRange(curTris * 4 * 4);
            
            infos = this.meshCollision.writeMeshBuffer(geo,  triArray, aabArrayBuffer, triangleMaterialMarkers, pathTracingMaterialList, this.materialCache);

            const triangleRange = this.triangeBuffer.getBufferRange(infos.t * 4 * 4, name);
            if(!triangleRange){
                console.log('rt buffer full');
                return null;
            }
            this.triangeBuffer.commitStagingRange(triangleRange, infos.t * 4);

            geometry = {transformation: transformation ,triangles: {n: infos.t, r: triangleRange}};

            console.log('addRTData triangleRange '+name+' '+ infos.t  + ' ' + triangleRange.start + '-' + triangleRange.end,' aabbRange ' + infos.a + ' materials ' + this.numMaterials);
        }
       
        const aabbRange = this.aabbBuffer.getBufferRange(infos.a * 8, name);
        this.aabbBuffer.commitStagingRange(aabbRange, infos.a * 8);

        geometry.aabbs = {n : infos.a, r: aabbRange};


        return {name : name, castShadow : true, geoID:null, geometry : geometry, materials : pathTracingMaterialList, children: []};
    }

    
    addRTMap(map, name) {

        let tid = -1;

        /*
        if( this.uniqueMaterialTextures.length>=64)
            return tid;
        */

        if (map === null)
            return tid;

        if ((map.source === null)|| (map.source.data === null))
        {
            console.warn('null map', map.source, map.source.data);
            return tid;
        }

        if(map.source.data.currentSrc)
        {
            for (let n = 0; n < this.uniqueMaterialTextures.length; n++) {
                if (this.uniqueMaterialTextures[n] == map.source.data.currentSrc)
                    return n;
            }
        }else{
            for (let n = 0; n < this.uniqueMaterialTextures.length; n++) {
                if (this.uniqueMaterialTextures[n] == name)
                    return n;
            }
        }

        let ret = null;

        while (ret === null) {
            ret = this.lastBigTexture.addTexture(map);

            if (!ret) {
                console.log('rt texture full '+name);
                this.lastBigTexture = new bigTex(this.renderer);
                this.BigTextures.push(this.lastBigTexture);
            }
        }

        tid = this.uniqueMaterialTextures.length;

        const texId = map.source.data.currentSrc ?map.source.data.currentSrc:name;

        this.uniqueMaterialTextures.push(texId);

        //this.uniqueMaterialTexturesTids[tid] = this.BigTextures.length - 1;
        
        this.matrix_array[FIRST_TEXID + tid * 4 + 0]=this.BigTextures.length - 1;

        this.matrix_array[FIRST_TEXCOORD + tid * 4 + 0]=ret.pos.x;
        this.matrix_array[FIRST_TEXCOORD + tid * 4 + 1]=ret.pos.y;
        this.matrix_array[FIRST_TEXCOORD + tid * 4 + 2]=ret.size.x;
        this.matrix_array[FIRST_TEXCOORD + tid * 4 + 3]=ret.size.y;
        

        /*
        console.log('addRTMap uniqueMaterialTextures', this.uniqueMaterialTextures);
        console.log('addRTMap uniqueMaterialTexturesTids', this.uniqueMaterialTexturesTids);
        console.log('addRTMap uniqueMaterialTexturesCoords', this.uniqueMaterialTexturesCoords);
        console.log('addRTMap BigTextures', this.BigTextures);
        */


        this.lastTexId++;
        return tid;
    }
    
    addBox(c, size, position, color, roughness, type) {

        const minC = position.clone().sub(size.multiplyScalar(0.5));
        const maxC = position.clone().add(size);
        
        c.mat = { color: { r: color.x, g: color.y, b: color.z } };
        c.object = { position: { x: position.x, y: position.y, z: position.z } };
        c.meshGPU = {box : {min : minC, max: maxC, roughness: roughness, type: type}, object: c.object, mat:c.mat};
    }

    
    addCylinder(c, radius, position, height, quat, color, roughness, type) {
        const hx = new THREE.Vector3(0, height / 2, 0).applyQuaternion(quat);

        const p1 = {
            x: position.x + hx.x,
            y: position.y + hx.y,
            z: position.z + hx.z
        };

        const p2 = {
            x: position.x - hx.x,
            y: position.y - hx.y,
            z: position.z - hx.z
        };

        const p = new THREE.Vector3(position.x, position.y, position.z);
        const q = new THREE.Quaternion(quat.x,quat.y,quat.z,quat.w);

        c.mat = { color: { r: color.x, g: color.y, b: color.z } };
        c.object = { position: p, quaternion: q };
        c.meshGPU = {cylinder : {radius: radius, type: type, roughness: roughness, p1: p1, p2: p2}, object : c.object, mat: c.mat};
    }

    addSphere(c, radius, position, emission, color, roughness, type) {

        c.mat = { color: { r: color.x, g: color.y, b: color.z }, emissive: { r: emission.x, g: emission.y, b: emission.z } };
        c.object = { position: { x: position.x, y: position.y, z: position.z } };
        c.meshGPU = {sphere : {radius : radius, emission: { r: emission.x, g: emission.y, b: emission.z}, roughness: roughness, type: type}, object: c.object, mat: c.mat};

    }

    addLight(c, position, color, radius, type) {
        c.mat = { color: { r: color.x, g: color.y, b: color.z } };
        c.object = { position: { x: position.x, y: position.y, z: position.z } };
        c.meshGPU = {light : {  type : type, 
                                radius : radius, 
                                angle : 0, 
                                dir : {x: 0, y: 0, z: 0}, 
                                object: c.object, 
                                mat: c.mat
                             }
                    };
    }

    setSunLight(pos, target) {
        /*
        this.SunSphere = {};
        this.addSphere(this.SunSphere, 10000.0, new THREE.Vector3(0, 0, 0), new THREE.Vector3(0.5, 0.7, 1.0).multiplyScalar(0.01), new THREE.Vector3(0, 0, 0), 0.1, RT_LIGHT); // Blueish sky light, z, 0.2, RT_LIGHT);
        */
    }

    addPointLight(sp, position, color, radius) {

        sp.mat = { color: { r: color.x, g: color.y, b: color.z } };
        sp.object = { position: { x: position.x, y: position.y, z: position.z } };
        sp.meshGPU = {light : {  type : RT_POINT_LIGHT, 
                                radius : radius, 
                                angle : 0.0,
                                dir : {x: 0, y: 0, z: 0}, 
                                object: sp.object, 
                                mat: sp.mat
                             }
                    };
    }

    addSpotLight(sp, position, dir, color, radius, aa) {
        sp.mat = { color: { r: color.x, g: color.y, b: color.z } };
        sp.object = { position: { x: position.x, y: position.y, z: position.z } };
        sp.meshGPU = {light : {  type : RT_SPOT_LIGHT, 
                                radius : radius, 
                                angle : aa,
                                dir : {x: dir.x, y: dir.y, z: dir.z}, 
                                object: sp.object, 
                                mat: sp.mat
                             }
                    };
    }
    addMeshInstance(meshGPU, transformation) {


        const mesh = {  geometry :  {    
                                        transformation: new Transformation3(transformation.position, transformation.quaternion) , 
                                        triangles: {n: meshGPU.geometry.triangles.n, r: null}, 
                                        vertices: meshGPU.geometry.vertices ?  {n: meshGPU.geometry.vertices.n, r: null} : null, 
                                        aabbs : {n : meshGPU.geometry.aabbs.n, r: null},
                                    },
                        geoID: null,
                        name : meshGPU.name,
                        children: [],
                        castShadow : meshGPU.castShadow};

        if(meshGPU.geometry.vertices)
            mesh.geometry.vertices.r = this.triangeBuffer.addRef(meshGPU.geometry.vertices.r);

        mesh.geometry.triangles.r = this.triangeBuffer.addRef(meshGPU.geometry.triangles.r);
        mesh.geometry.aabbs.r = this.aabbBuffer.addRef(meshGPU.geometry.aabbs.r);

        return mesh;
    }

    ThreeToMat(imat, matType){
        let mat = new MaterialObject();

        mat.name = imat.name;
        mat.type = matType;
        mat.matId = -1;

        mat.albedoTextureID = -1;
        mat.normalTextureID = -1;
        mat.emissiveTextureID = -1;
        mat.alphaTextureID= -1;

        mat.color = {r : imat.color.r, g : imat.color.g, b : imat.color.b}; //{r:100.0, g:0.5, b:0.25, a : 1.0};
        mat.roughness = imat.roughness || 0.2;
        mat.metalness = imat.metalness || 0.2;
        mat.emissive = imat.emissive || { r:0, g:0, b:0 };
        mat.emissiveIntensity = imat.emissiveIntensity;
        mat.opacity = imat.opacity || 1.0;
        mat.bumpMap = imat.bumpMap ? true : false;
        mat.refractiveIndex = 1.0;
        mat.transparent = imat.transparent ? 1.0 : 0.0;
        mat.ior = imat.ior ? imat.ior : 1.2;

        mat.uvScale = { x: 1, y: 1 };
        mat.uvOfffset = { x: 0, y: 0 };


        if ((imat.emissiveMap) && (imat.emissiveMap.source)) {
            mat.emissiveTextureID = this.addRTMap(imat.emissiveMap, imat.name+'-emm');
            mat.uvScale = imat.emissiveMap.repeat;
            mat.uvOfffset = imat.emissiveMap.offset;
        }
        if ((imat.map) && (imat.map.source)) {
            mat.albedoTextureID = this.addRTMap(imat.map, imat.name+'-tex');
            mat.uvScale = imat.map.repeat;
            mat.uvOfffset = imat.map.offset;
        }

        if ((imat.alphaMap) && (imat.alphaMap.source)) {
            mat.alphaTextureID = this.addRTMap(imat.alphaMap, imat.name+'-alpha');
            mat.uvScale = imat.map.repeat;
            mat.uvOfffset = imat.map.offset;
        }
  
        return mat;
    }


    addMesh(meshGroup, matType = RT_DIFF, transformation = new Transformation3(), applyMats = false, myfilter = noFilter, flip = {x: false,y: false,z: false}) {
        const self = this;

        const sx = flip.x ? -1 : 1;
        const sy = flip.y ? -1 : 1;
        const sz = flip.z ? -1 : 1;

        const det = sx * sy * sz;
        const ids =(det > 0) ? [0,1,2]:[2,1,0];

        //console.log('addMesh meshGroup ' + meshGroup.name);
        
        if((meshGroup.isMesh) && (meshGroup.geometry.attributes.position.count <= 0)) {
            return {
                        geometry : 
                        { 
                            transformation: transformation ,
                            triangles: {n: 0, r: null}, aabbs : {n : 0, r: null}
                        }, 
                        geoID:null,
                        materials : null, 
                        children: []
                    };
        }
        

        const materialCache = {};

        meshGroup.traverse(function (child) {
            if (!child.isMesh)
                return;

            if(child.geometry.name === "ToonFlippedGeo")
                return;


            //console.log('addMesh child ' + meshGroup.name+'->'+child.name);

            const childGeo = self.isIndexed ? child.geometry : child.geometry.clone().toNonIndexed();

            if (child.material.length > 0) {
                let j = 0;
                //for (let j = 0; j < child.material.length; j++) {

                for (let g =0;g<childGeo.groups.length;g++) {

                    const grp = childGeo.groups[g];
                    const j = grp.materialIndex;
                    const imat = child.material[j];

                    if(imat.name.length<1)
                        continue;

                    if( (imat.name.startsWith('center'))||
                        (imat.name.startsWith('bone'))||
                        (imat.name.startsWith('ccube'))||
                        (imat.name.startsWith('Anchor')))
                    continue;

                    if(imat.opacity<0.3)
                        continue;

                    if(!myfilter(child, imat))
                        continue;

                    if(!materialCache[ meshGroup.name +'-'+imat.name]) {

                        if(!self.materialCache[meshGroup.name +'-'+imat.name] )
                            self.materialCache[meshGroup.name +'-'+imat.name] = self.ThreeToMat(imat, matType)
    
                        materialCache[meshGroup.name +'-'+imat.name] = {mat : meshGroup.name +'-'+imat.name, geo : null};
                    }

                    const nVertices = childGeo.attributes.position.count;
                    const grpGeo = new THREE.BufferGeometry();

                    if(childGeo.index) {

                        const nTriangles = grp.count / 3;
                        const indexes = new Float32Array(nTriangles * 3);
    
                        const indexCache = new Uint16Array(nVertices);
                        indexCache.fill(0xFFFF, 0, indexCache.length);

                        let nVtx = 0;

                        for (let v = 0; v < grp.count; v++) {
                            const index = childGeo.index.array[v];
                            
                            if(indexCache[index] == 0xFFFF){
                                indexCache[index] = nVtx;
                                nVtx++;
                            }
                        }

                        const positions = new Float32Array(nVtx * 3);
                        const normals = new Float32Array(nVtx * 3);
                        const uvs = new Float32Array(nVtx * 2);

                        nVtx = 0;
                        indexCache.fill(0xFFFF, 0, indexCache.length);
    
                        for (let v = 0; v < grp.count; v+=3) {
                            for(let i =0;i<3;i++) {
                                const triIndex =grp.start + v + ids[i];
                                const index = childGeo.index.array[triIndex];
                              
                                if(indexCache[index] == 0xFFFF){
                                    positions[nVtx * 3.0 + 0] = childGeo.attributes.position.array[index * 3.0 + 0] * sx;
                                    positions[nVtx * 3.0 + 1] = childGeo.attributes.position.array[index * 3.0 + 1] * sy;
                                    positions[nVtx * 3.0 + 2] = childGeo.attributes.position.array[index * 3.0 + 2] * sz;
            
                                    normals[nVtx * 3.0 + 0] = childGeo.attributes.normal.array[index * 3.0 + 0] * sx;
                                    normals[nVtx * 3.0 + 1] = childGeo.attributes.normal.array[index * 3.0 + 1] * sy;
                                    normals[nVtx * 3.0 + 2] = childGeo.attributes.normal.array[index * 3.0 + 2] * sz;
            
                                    if(childGeo.attributes.uv){
                                        uvs[nVtx * 2.0 + 0] = self.materialCache[meshGroup.name +'-'+imat.name].uvOfffset.x + (childGeo.attributes.uv.array[index * 2.0 + 0] * self.materialCache[meshGroup.name +'-'+imat.name].uvScale.x);
                                        uvs[nVtx * 2.0 + 1] = self.materialCache[meshGroup.name +'-'+imat.name].uvOfffset.y + (childGeo.attributes.uv.array[index * 2.0 + 1] * self.materialCache[meshGroup.name +'-'+imat.name].uvScale.y);
                                    }
        
                                    indexCache[index] = nVtx;
                                    nVtx++;
                                }
    
                                indexes[(v + i)] = indexCache[index] ;
                            }
                        }
                        grpGeo.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
                        grpGeo.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
                        grpGeo.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
                        grpGeo.setIndex(new Uint16BufferAttribute(indexes, 1));
                    }else{

                        const positions = new Float32Array(grp.count * 3);
                        const normals = new Float32Array(grp.count * 3);
                        const uvs = new Float32Array(grp.count * 2);

                        for (let v = 0; v < grp.count; v+=3) {

                            for(let i =0;i<3;i++) {

                                const triIndex = grp.start + v + ids[i];

                                positions[(v + i) * 3.0 + 0] = childGeo.attributes.position.array[triIndex * 3.0 + 0] * sx;
                                positions[(v + i) * 3.0 + 1] = childGeo.attributes.position.array[triIndex * 3.0 + 1] * sy;
                                positions[(v + i) * 3.0 + 2] = childGeo.attributes.position.array[triIndex * 3.0 + 2] * sz;

                                normals[(v + i) * 3.0 + 0] = childGeo.attributes.normal.array[triIndex * 3.0 + 0] * sx;
                                normals[(v + i) * 3.0 + 1] = childGeo.attributes.normal.array[triIndex * 3.0 + 1] * sy;
                                normals[(v + i) * 3.0 + 2] = childGeo.attributes.normal.array[triIndex * 3.0 + 2] * sz;

                                if((childGeo.attributes.uv)&&(self.materialCache[meshGroup.name +'-'+imat.name].uvOfffset)){
                                    uvs[(v + i) * 2.0 + 0] =  self.materialCache[meshGroup.name +'-'+imat.name].uvOfffset.x + (childGeo.attributes.uv.array[triIndex * 2.0 + 0] *  self.materialCache[meshGroup.name +'-'+imat.name].uvScale.x);
                                    uvs[(v + i) * 2.0 + 1] =  self.materialCache[meshGroup.name +'-'+imat.name].uvOfffset.y + (childGeo.attributes.uv.array[triIndex * 2.0 + 1] *  self.materialCache[meshGroup.name +'-'+imat.name].uvScale.y);
                                }
                            }
                        }
                        grpGeo.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
                        grpGeo.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
                        grpGeo.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
                    }

                    if(applyMats){
                        child.updateWorldMatrix(true);
                        grpGeo.applyMatrix4(child.matrixWorld);
                    }

                    if(!materialCache[meshGroup.name +'-'+imat.name].geo){
                        materialCache[meshGroup.name +'-'+imat.name].geo = grpGeo;
                    }else{
                        materialCache[meshGroup.name +'-'+imat.name].geo = mergeGeometries([materialCache[meshGroup.name +'-'+imat.name].geo, grpGeo]);
                    }
                }
            } else {

                const imat = child.material;

                if(!myfilter(child, imat))
                    return;
                
                if(!materialCache[meshGroup.name +'-'+imat.name]) {

                    if(!self.materialCache[meshGroup.name +'-'+imat.name] )
                        self.materialCache[meshGroup.name +'-'+imat.name] = self.ThreeToMat(imat, matType)

                    materialCache[meshGroup.name +'-'+imat.name] = { mat : meshGroup.name +'-'+imat.name, geo : null};
                }

                const grpGeo = new THREE.BufferGeometry();

                const nVertices = childGeo.attributes.position.count;

                const positions = new Float32Array(nVertices * 3);
                const normals = new Float32Array(nVertices * 3);
                const uvs = new Float32Array(nVertices * 2);

                if(childGeo.index) {

                    const nTriangles = childGeo.index.count / 3;
                    const indexes = new Float32Array(nTriangles * 3);

                    const indexCache = new Uint16Array(nVertices);
                    indexCache.fill(0xFFFF, 0, indexCache.length);

                    let nVtx = 0;

                    for (let t = 0; t < nTriangles * 3; t+=3) {
                        for(let i =0;i<3;i++) {
                            const triIndex = t + ids[i];
                            const index = childGeo.index.array[triIndex];
                          
                            if(indexCache[index] == 0xFFFF){
                                positions[nVtx * 3.0 + 0] = childGeo.attributes.position.array[index * 3.0 + 0] * sx;
                                positions[nVtx * 3.0 + 1] = childGeo.attributes.position.array[index * 3.0 + 1] * sy;
                                positions[nVtx * 3.0 + 2] = childGeo.attributes.position.array[index * 3.0 + 2] * sz;
        
                                normals[nVtx * 3.0 + 0] = childGeo.attributes.normal.array[index * 3.0 + 0] * sx;
                                normals[nVtx * 3.0 + 1] = childGeo.attributes.normal.array[index * 3.0 + 1] * sy;
                                normals[nVtx * 3.0 + 2] = childGeo.attributes.normal.array[index * 3.0 + 2] * sz;
        
                                if(childGeo.attributes.uv){
                                    uvs[nVtx * 2.0 + 0] = self.materialCache[meshGroup.name +'-'+imat.name].uvOfffset.x + (childGeo.attributes.uv.array[index * 2.0 + 0] * self.materialCache[meshGroup.name +'-'+imat.name].uvScale.x);
                                    uvs[nVtx * 2.0 + 1] = self.materialCache[meshGroup.name +'-'+imat.name].uvOfffset.y + (childGeo.attributes.uv.array[index * 2.0 + 1] * self.materialCache[meshGroup.name +'-'+imat.name].uvScale.y);
                                }
    
                                indexCache[index] = nVtx;
                                nVtx++;
                            }

                            indexes[(t + i)] = indexCache[index] ;
                        }
                    }

                    grpGeo.setIndex(new Uint16BufferAttribute(indexes, 1));
                }else{
                    for (let v = 0; v < nVertices; v+=3) {

                        for(let i =0;i<3;i++) {
    
                            const triIndex = v + ids[i];
    
                            positions[(v + i) * 3.0 + 0] = childGeo.attributes.position.array[triIndex * 3.0 + 0] * sx;
                            positions[(v + i) * 3.0 + 1] = childGeo.attributes.position.array[triIndex * 3.0 + 1] * sy;
                            positions[(v + i) * 3.0 + 2] = childGeo.attributes.position.array[triIndex * 3.0 + 2] * sz;
    
                            normals[(v + i) * 3.0 + 0] = childGeo.attributes.normal.array[triIndex * 3.0 + 0] * sx;
                            normals[(v + i) * 3.0 + 1] = childGeo.attributes.normal.array[triIndex * 3.0 + 1] * sy;
                            normals[(v + i) * 3.0 + 2] = childGeo.attributes.normal.array[triIndex * 3.0 + 2] * sz;
    
                            if(childGeo.attributes.uv){
                                uvs[(v + i) * 2.0 + 0] = self.materialCache[meshGroup.name +'-'+imat.name].uvOfffset.x + (childGeo.attributes.uv.array[triIndex * 2.0 + 0] * self.materialCache[meshGroup.name +'-'+imat.name].uvScale.x);
                                uvs[(v + i) * 2.0 + 1] = self.materialCache[meshGroup.name +'-'+imat.name].uvOfffset.y + (childGeo.attributes.uv.array[triIndex * 2.0 + 1] * self.materialCache[meshGroup.name +'-'+imat.name].uvScale.y);
                            }
                        }
                    }
                }

                grpGeo.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
                grpGeo.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
                grpGeo.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));

                if(applyMats){
                    child.updateWorldMatrix(true);
                    grpGeo.applyMatrix4(child.matrixWorld);
                }

                if(!materialCache[meshGroup.name +'-'+imat.name].geo){
                    materialCache[meshGroup.name +'-'+imat.name].geo = grpGeo;
                }else{
                    materialCache[meshGroup.name +'-'+imat.name].geo = mergeGeometries([materialCache[meshGroup.name +'-'+imat.name].geo, grpGeo]);
                }
            }
            
        });

        if(Object.keys(materialCache).length <= 0 )
            return null;

        let matIdx =0;
        let numTriangles = 0;
        
        const geoList = [];
        const materialNames = [];
        const triangleMaterialMarkers = [];
        const pathTracingMaterialList = [];

        for(let name in materialCache){
            numTriangles += materialCache[name].geo.index ? materialCache[name].geo.index.count /3 : materialCache[name].geo.attributes.position.count / 3;
            triangleMaterialMarkers[matIdx] = numTriangles;
            geoList.push(materialCache[name].geo);
            materialNames.push(name);
            matIdx++;
        }
        const geo = mergeGeometries(geoList);

        //console.log('addMesh geometry : ', geo, 'markers :', triangleMaterialMarkers, ' materials :', pathTracingMaterialList, 'textures :', this.uniqueMaterialTextures);

        return this.addRTData(geo, transformation, triangleMaterialMarkers, materialNames, meshGroup.name);
    }

    drawMesh(m, pipe =null, parentTransform=null) {

        if(!m)
            return;

        if(m.geometry) {

            const g = m.geometry;
            let t;

            if(parentTransform !== null) {
                t = new Transformation3();
                parentTransform.multiply2(g.transformation, t);
            }else   
                t = g.transformation;

            const isRecyled = this.recyledGeoIds.length > 0 ? true : false;
            m.geoID = isRecyled ? this.recyledGeoIds. pop() : this.nGeometries;

            const rn = isRecyled ? 'recyled ' : ' '
            console.log('drawMesh '+m.name+' '+ rn + m.geoID+' '+g.triangles.r.start+' '+g.triangles.n);

            if(!m.name){
                console.warn('no name mesh '+m.geoID);
            }

            this.meshNames[m.geoID] = m.name;
            this.meshPos[m.geoID] = t.position;

            const idx = m.geoID * 16;

            if(g.vertices){
                this.matrix_array[idx+0] = g.triangles.r.start / ( 4 * 4);
                this.matrix_array[idx+1] = g.aabbs.r.start / ( 8 * 4);
                this.matrix_array[idx+2] = g.vertices.r.start  / ( 8 * 4);
                this.matrix_array[idx+3] = g.aabbs.n;

            }else if(g.triangles){
    
                this.matrix_array[idx+0] = g.triangles.r.start / ( 16 * 4);
                this.matrix_array[idx+1] = g.aabbs.r.start / ( 8 * 4);
        
                this.matrix_array[idx+2] = -1.0;
                this.matrix_array[idx+3] = g.aabbs.n;
            }

            t.getViewTransform(this.it);
        
            //matrix.clone().invert().toArray(mM);
    
            this.matrix_array[idx+4] = this.it.m3[0];
            this.matrix_array[idx+5] = this.it.m3[1];
            this.matrix_array[idx+6] = this.it.m3[2];
            this.matrix_array[idx+7] = this.it.m3[3];
    
            this.matrix_array[idx+8] = this.it.m3[4];
            this.matrix_array[idx+9] = this.it.m3[5];
            this.matrix_array[idx+10] = this.it.m3[6];
            this.matrix_array[idx+11] = this.it.m3[7];
    
            this.matrix_array[idx+12] = this.it.m3[8];
            this.matrix_array[idx+13] = this.it.position.x;
            this.matrix_array[idx+14] = this.it.position.y;
            this.matrix_array[idx+15] = this.it.position.z;
        
            if(!isRecyled)
                this.nGeometries++;
                
            for(let n=0;n<m.children.length;n++){
                this.drawMesh(m.children[n], null, t);
            }

            return;
        }

        if(m.light) {

            const lightArray = this.matrix_array.subarray(FIRST_LIGHT + this.numLights * 12, FIRST_LIGHT + (this.numLights + 1) * 12);
            const l = m.light;

            lightArray[0] = l.object.position.x;
            lightArray[1] = l.object.position.y;
            lightArray[2] = l.object.position.z;
            lightArray[3] = l.radius;

            lightArray[4] = l.mat.color.r;
            lightArray[5] = l.mat.color.g;
            lightArray[6] = l.mat.color.b;
            lightArray[7] = l.angle;

            lightArray[8] = l.dir.x;
            lightArray[9] = l.dir.y;
            lightArray[10] = l.dir.z;
            lightArray[11] = l.type;

            this.numLights++;

            return;
        }

        if(m.sphere) {

            //const sphereArray = this.matrix_array.subarray(FIRST_SPHERE + this.numSpheres * 12, FIRST_SPHERE + (this.numSpheres + 1) * 12);
            const s = m.sphere;
            const idx = FIRST_SPHERE + this.numSpheres * 12;

            this.matrix_array[idx+0] = m.object.position.x;
            this.matrix_array[idx+1] = m.object.position.y;
            this.matrix_array[idx+2] = m.object.position.z;
            this.matrix_array[idx+3] = s.radius;

            this.matrix_array[idx+4] = m.mat.color.r;
            this.matrix_array[idx+5] = m.mat.color.g;
            this.matrix_array[idx+6] = m.mat.color.b;
            this.matrix_array[idx+7] = s.roughness;

            this.matrix_array[idx+8] = s.emission.r;
            this.matrix_array[idx+9] = s.emission.g;
            this.matrix_array[idx+10] = s.emission.b;
            this.matrix_array[idx+11] = s.type;

            this.numSpheres++;

            return;
        }
        
        
        if(m.box)
        {
            const cubeArray = this.matrix_array.subarray(FIRST_BOX + this.numCubes * 12, FIRST_BOX + (this.numCubes + 1) * 12);
            const box = m.box;

            cubeArray[0] = box.min.x;
            cubeArray[1] = box.min.y;
            cubeArray[2] = box.min.z;
            cubeArray[3] = box.max.x;

            cubeArray[4] = box.max.y;
            cubeArray[5] = box.max.z;
            cubeArray[6] = box.roughness;
            cubeArray[7] = box.type;

            cubeArray[8] = m.mat.color.r;
            cubeArray[9] = m.mat.color.g;
            cubeArray[10] = m.mat.color.b;
            cubeArray[11] = 0;

            //console.log('add box ', cubeArray);

            this.numCubes++;
            return;
        }
        
        if(m.cylinder) {
            
            const CylinderArray = this.matrix_array.subarray(FIRST_CYLINDER + this.numCylinders * 12, FIRST_CYLINDER + (this.numCylinders + 1) * 12);
            const cyl = m.cylinder;
            
            CylinderArray[0] = cyl.p1.x;
            CylinderArray[1] = cyl.p1.y;
            CylinderArray[2] = cyl.p1.z;
            CylinderArray[3] = cyl.radius;

            CylinderArray[4] = cyl.p2.x;
            CylinderArray[5] = cyl.p2.y;
            CylinderArray[6] = cyl.p2.z;
            CylinderArray[7] = cyl.roughness;

            CylinderArray[8] = m.mat.color.r;
            CylinderArray[9] = m.mat.color.g;
            CylinderArray[10] = m.mat.color.b;
            CylinderArray[11] = cyl.type;

            
            this.numCylinders++;
            return;
        }
    }

    
    updateTransform(gm, t){

        const g = gm.geometry;

        if(!g.triangles.r)
            return;

        if(!g.aabbs.r)
            return;

        const idx = gm.geoID * 16;

        if (g.vertices) {
            this.matrix_array[idx + 0] = g.triangles.r.start / (4 * 4);
            this.matrix_array[idx + 1] = g.aabbs.r.start / (8 * 4);
            this.matrix_array[idx + 2] = g.vertices.r.start / (8 * 4);
            this.matrix_array[idx + 3] = g.aabbs.n;

        } else if (g.triangles) {

            this.matrix_array[idx + 0] = g.triangles.r.start / (16 * 4);
            this.matrix_array[idx + 1] = g.aabbs.r.start / (8 * 4);
            this.matrix_array[idx + 2] = -1.0;
            this.matrix_array[idx + 3] = g.aabbs.n;
        }

        t.getViewTransform(this.it);

        this.matrix_array[idx + 4] = this.it.m3[0];
        this.matrix_array[idx + 5] = this.it.m3[1];
        this.matrix_array[idx + 6] = this.it.m3[2];
        this.matrix_array[idx + 7] = this.it.m3[3];

        this.matrix_array[idx + 8] = this.it.m3[4];
        this.matrix_array[idx + 9] = this.it.m3[5];
        this.matrix_array[idx + 10] = this.it.m3[6];
        this.matrix_array[idx + 11] = this.it.m3[7];

        this.matrix_array[idx + 12] = this.it.m3[8];
        this.matrix_array[idx + 13] = this.it.position.x;
        this.matrix_array[idx + 14] = this.it.position.y;
        this.matrix_array[idx + 15] = this.it.position.z;
    }
    
    update(time, dt, cameraPosition = null) {

        const v = new THREE.Vector3();

        for(let mi=0;mi<this.rtMeshes.length;mi++){

            this.rtMeshes[mi].uNumSpheres = this.numSpheres;
            this.rtMeshes[mi].uNumGeometries = 0;

            const idx = FIRST_GEOLIST + this.rtMeshes[mi].uGeoIndex * 4;

            for(let i =0;i<this.rtMeshes[mi].rtGeos.length;i++){

                const geoid = this.rtMeshes[mi].rtGeos[i];
                if((cameraPosition === null) || (cameraPosition.distanceTo(this.meshPos[geoid])< 1000)){
                    this.matrix_array[idx + this.rtMeshes[mi].uNumGeometries] = geoid;
                    this.rtMeshes[mi].uNumGeometries++;
                }
            }

             for(let i =0;i<this.alwaysRender.length;i++){
                const geoid = this.alwaysRender[i];
                const gidx = this.rtMeshes[mi].rtGeos.indexOf(geoid);
                if(gidx<0){

                    v.subVectors(this.meshPos[geoid], this.rtMeshes[mi].position);
                    if(this.rtMeshes[mi].geometry.boundingBox.containsPoint(v)){
                        this.matrix_array[idx + this.rtMeshes[mi].uNumGeometries] = geoid;
                        this.rtMeshes[mi].uNumGeometries++;
                    }
                }
            }
        }
            
        if(this.MatrixDataTexture){
            this.MatrixDataTexture.needsUpdate = true;
        }
    }
}

class EngineRT extends EngineBase {

    renderer;

    constructor(audio = false, matType = 1) {

        super(audio, matType);


        const w = $('#gl-dom').innerWidth();
        const h = $('#gl-dom').innerHeight();

        this.renderer = new THREE.WebGLRenderer();
        this.renderer.setSize(w, h);

        this.fogDensity = 0;

        this.matrix_array = new Float32Array(lineWith * 8 * 4);
        

        this.nGeometries = 0;
        this.numSpheres = 0;
        this.numCubes = 0;
        this.numCylinders = 0;
        this.numMaterials = 0;
        this.particlesId = 1;

        this.particles = [];
        this.hiddenObjects = [];
        this.shadowSrc = {};
        this.SkyBox = {};
        this.uniqueMaterialTextures = [];
        this.meshInstances = [];

        this.accumSample = true;
        this.renderTargetX = 1024;
        this.renderTargetY = 768;
        
        this.renderPass = {};
  
        this.cameraTransform= new Transformation3();
        this.camera = new THREE.PerspectiveCamera(this.cameraFOV, w / h, 0.8, 700);
        this.elapsedTime=0;
      

    }
    destroyTrack (){
        this.resetTex();
    }

    removeRain(){
        
    }
    resetTex(){
        
        this.uniqueMaterialTextures = [];
        this.uniqueMaterialTexturesTids = new Array(256);
        this.uniqueMaterialTexturesCoords = new Array(256);

        this.numMaterials = 0;
        this.lastTexId = 0;

        for (let n = 0; n < this.uniqueMaterialTexturesCoords.length; n++) {
            this.uniqueMaterialTexturesCoords[n] = new THREE.Vector4(0, 0, 0, 0);
        }
        this.lastBigTexture = new bigTex(this.renderer);
        this.BigTextures = [this.lastBigTexture];
    }

    initVR(enableVRFunc){

        this.myVRButton = VRButton.createButton( this.renderer );
        document.body.append(this.myVRButton);

        this.renderer.xr.enabled = true;
        this.renderer.xr.setReferenceSpaceType( 'local' );

        this.renderer.xr.addEventListener( 'sessionstart', function ( event ) { enableVRFunc(true); } );
        this.renderer.xr.addEventListener( 'sessionend', function ( event ) { enableVRFunc(false); } );

    }

    initEngineUI(){

        const self = this;

        var myDefaultWhiteList = $.fn.tooltip.Constructor.Default.whiteList
        // To allow table elements
        myDefaultWhiteList.input = []
        myDefaultWhiteList.button = []

        $('#engine-settings').popover({ html: true, content: 'x : <input id="rt-res-x"/> y: <input id="rt-res-y"/>' });

        $('#engine-settings').on('shown.bs.popover', function (e) {

            $('#rt-res-x').val(self.renderTargetX);
            $('#rt-res-y').val(self.renderTargetY);
            $('#rt-res-x').on('change', function(){ self.renderTargetX = parseInt(this.value); });
            $('#rt-res-y').on('change', function(){ self.renderTargetY = parseInt(this.value); });
        });


    }

    async initRT(shader, shader2 = '/assets/shaders/ScreenOutput_Fragment.glsl') {
        await ready;


        initShaders();

        this.pathTracingScene = new THREE.Scene();
        this.screenCopyScene = new THREE.Scene();
        this.screenOutputScene = new THREE.Scene();

        this.nPasses = 1;
        this.totalFrames = 0;
        this.demoFragmentShaderFileName = shader;

        // scene/demo-specific three.js objects setup goes here

        // pixelRatio is resolution - range: 0.5(half resolution) to 1.0(full resolution)
        this.pixelRatio = 0.75; // less demanding on battery-powered mobile devices

        this.EPS_intersect = 0.001;

        //this.camera = new THREE.OrthographicCamera(-100, 100, 100, -100, 0, 1000); 
        //this.camera = new THREE.PerspectiveCamera(this.cameraFOV, w / h, 0.8, 700);

        //this.pathTracingScene.add(this.camera);

        this.pathTracingUniforms = {};
        this.pathTracingUniformsGroups = [];

        this.renderer.toneMapping = THREE.ReinhardToneMapping;

        //required by WebGL 2.0 for rendering to FLOAT textures
        this.renderer.getContext().getExtension('EXT_color_buffer_float');

        this.renderer.autoClear = false;

        // quadCamera is simply the camera to help render the full screen quad (2 triangles),
        // hence the name.  It is an Orthographic camera that sits facing the view plane, which serves as
        // the window into our 3d world. This camera will not move or rotate for the duration of the app.
        this.quadCamera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
        this.screenCopyScene.add(this.quadCamera);
        this.screenOutputScene.add(this.quadCamera);

        const ctx = this.renderer.getContext();

        // setup render targets...
        this.pathTracingRenderTarget = new THREE.WebGLRenderTarget(this.renderTargetX, this.renderTargetY, {
            minFilter: THREE.LinearFilter,
            magFilter: THREE.LinearFilter,
            format: THREE.RGBAFormat,
            type: THREE.FloatType,
            depthBuffer: false,
            stencilBuffer: false
        });
        this.pathTracingRenderTarget.texture.generateMipmaps = false;

        this.screenCopyRenderTarget = new THREE.WebGLRenderTarget(ctx.drawingBufferWidth, ctx.drawingBufferHeight, {
            minFilter: THREE.NearestFilter,
            magFilter: THREE.NearestFilter,
            format: THREE.RGBAFormat,
            type: THREE.FloatType,
            depthBuffer: false,
            stencilBuffer: false
        });
        this.screenCopyRenderTarget.texture.generateMipmaps = false;

        
        const lineStride = lineSize * 4;

        this.triangeBuffer = new BufferAllocator(lineWith, lineStride, 2);
        this.aabbBuffer = new BufferAllocator(lineWith, lineStride, 2);
        this.meshCollision = new MeshCollision(lineWith);

        this.MatrixDataTexture = new THREE.DataTexture(this.matrix_array,
            lineWith,
            16,
            THREE.RGBAFormat,
            THREE.FloatType,
            THREE.Texture.DEFAULT_MAPPING,
            THREE.ClampToEdgeWrapping,
            THREE.ClampToEdgeWrapping,
            THREE.NearestFilter,
            THREE.NearestFilter,
            1,
            THREE.NoColorSpace);

        this.MatrixDataTexture.encoding = THREE.LinearEncoding;
        this.MatrixDataTexture.flipY = false;
        this.MatrixDataTexture.generateMipmaps = false;
        this.MatrixDataTexture.needsUpdate = true;
        this.initScene();

        const ntex = await this.texLoader.load('/assets/textures/BlueNoise_RGBA256.png');

        ntex.wrapS = THREE.RepeatWrapping;
        ntex.wrapT = THREE.RepeatWrapping;
        ntex.flipY = false;
        ntex.minFilter = THREE.NearestFilter;
        ntex.magFilter = THREE.NearestFilter;
        ntex.generateMipmaps = false;

        this.blueNoiseTexture = ntex;

        const texture = await this.texLoader.load(this.assetBase+'/assets/textures/darkWood.jpg');
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.flipY = false;
        texture.minFilter = THREE.NearestFilter;
        texture.magFilter = THREE.NearestFilter;
        texture.generateMipmaps = false;

        this.darkWoodTexture = texture

        this.pathTracingGeometry = new THREE.PlaneGeometry(2, 2);

        // scene/demo-specific uniforms go here
        this.pathTracingUniforms.tTriangleTexture = { value: this.triangeBuffer.buffer };
        this.pathTracingUniforms.tAABBTexture = { value: this.aabbBuffer.buffer };
        this.pathTracingUniforms.tMatrixTexture = { value: this.MatrixDataTexture };
        this.pathTracingUniforms.tBumpMap = { type: "t",  value: this.bumpTex };
        this.pathTracingUniforms.bumpMapScale = { type: "v2", value: new THREE.Vector2() };
        this.pathTracingUniforms.bumpScale = { type: "f", value: 1.0 };
        this.pathTracingUniforms.tPreviousTexture = { type: "t", value: this.screenCopyRenderTarget.texture };
        this.pathTracingUniforms.tBlueNoiseTexture = { type: "t", value: this.blueNoiseTexture };
        this.pathTracingUniforms.tDarkWoodTexture = { type: "t", value: this.darkWoodTexture };
        this.pathTracingUniforms.uCameraMatrix = { type: "m4", value: new THREE.Matrix4() };
        this.pathTracingUniforms.uNumGeometries = { type: "f", value: this.nGeometries };
        this.pathTracingUniforms.uResolution = { type: "v2", value: new THREE.Vector2() };
        this.pathTracingUniforms.uRandomVec2 = { type: "v2", value: new THREE.Vector2() };
        this.pathTracingUniforms.uEPS_intersect = { type: "f", value: this.EPS_intersect };
        this.pathTracingUniforms.uTime = { type: "f", value: 0.0 };
        this.pathTracingUniforms.uSampleCounter = { type: "f", value: 0.0 }; //0.0
        this.pathTracingUniforms.uPreviousSampleCount = { type: "f", value: 1.0 };
        this.pathTracingUniforms.uFrameCounter = { type: "f", value: 1.0 }; //1.0
        this.pathTracingUniforms.uULen = { type: "f", value: 1.0 };
        this.pathTracingUniforms.uVLen = { type: "f", value: 1.0 };
        this.pathTracingUniforms.uApertureSize = { type: "f", value: this.apertureSize };
        this.pathTracingUniforms.uFocusDistance = { type: "f", value: this.focusDistance };
        this.pathTracingUniforms.tEnvMap = { type: "t", value: this.skyTexture };
        this.pathTracingUniforms.uCameraIsMoving = { type: "b1", value: false };
        this.pathTracingUniforms.uUseOrthographicCamera = { type: "b1", value: false };

        this.pathTracingUniforms.tAlbedoTextures = { value : [{ type: "t" , value: this.darkWoodTexture }] };
        this.pathTracingUniforms.uAlbedoCoords = { value: this.uniqueMaterialTexturesCoords };
        this.pathTracingUniforms.uAlbedoTexturesIds = { value: this.uniqueMaterialTexturesTids };

        console.log('initRT : pathTracingUniforms', this.pathTracingUniforms);

        /*
        this.pathTracingDefines = {
            NUMBER_OF_TRIANGLES: this.total_number_of_triangles
        };
        */

        // this full-screen quad mesh copies the image output of the pathtracing shader and feeds it back in to that shader as a 'previousTexture'
        this.screenCopyGeometry = new THREE.PlaneGeometry(2, 2);


        this.screenCopyUniforms = {
            tPathTracedImageTexture: { type: "t", value: this.pathTracingRenderTarget.texture }
        };

        this.pixelEdgeSharpness = 0.004;
        this.edgeSharpenSpeed = 0.4;
        this.filterDecaySpeed = 0.02;
        this.sceneIsDynamic = false;
        this.useToneMapping = false;

        this.screenOutputUniforms = {
            tPathTracedImageTexture: { type: "t", value: this.pathTracingRenderTarget.texture },
            uSampleCounter: { type: "f", value: 1.0 },
            uOneOverSampleCounter: { type: "f", value: 1.0 },
            uPixelEdgeSharpness: { type: "f", value: this.pixelEdgeSharpness },
            fScaleX: { type: "f", value: ctx.drawingBufferWidth / this.renderTargetX },
            fScaleY: { type: "f", value: ctx.drawingBufferHeight / this.renderTargetY },
            uEdgeSharpenSpeed: { type: "f", value: this.edgeSharpenSpeed },
            uFilterDecaySpeed: { type: "f", value: this.filterDecaySpeed },
            uSceneIsDynamic: { type: "b1", value: this.sceneIsDynamic },
            uUseToneMapping: { type: "b1", value: this.useToneMapping }
        };
        // this full-screen quad mesh takes the image output of the path tracing shader (which is a continuous blend of the previous frame and current frame),
        // and applies gamma correction (which brightens the entire image), and then displays the final accumulated rendering to the screen
        this.screenOutputGeometry = new THREE.PlaneGeometry(2, 2);
        


        // load vertex and fragment shader files that are used in the pathTracing material, mesh and scene
        const vs = await fetch(this.assetBase+'/assets/shaders/common_PathTracing_Vertex.glsl');
        this.pathTracingVertexShader = await vs.text();

        const fs = await fetch(this.assetBase+'/assets/shaders/' + this.demoFragmentShaderFileName);
        this.pathTracingFragmentShader = await fs.text();

        this.pathTracingMaterial = new THREE.ShaderMaterial({
            uniforms: this.pathTracingUniforms,
            //uniformsGroups: self.pathTracingUniformsGroups,
            defines: this.pathTracingDefines,
            vertexShader: this.pathTracingVertexShader,
            fragmentShader: this.pathTracingFragmentShader,
            depthTest: false,
            depthWrite: false
        });

        this.pathTracingMesh = new THREE.Mesh(this.pathTracingGeometry, this.pathTracingMaterial);
        this.pathTracingScene.add(this.pathTracingMesh);
        this.pathTracingScene.add(this.cameraAnchor);

        // the following keeps the large scene ShaderMaterial quad right in front 
        //   of the camera at all times. This is necessary because without it, the scene 
        //   quad will fall out of view and get clipped when the camera rotates past 180 degrees.
        this.camera.add(this.pathTracingMesh);

        const scf = await fetch(this.assetBase+'/assets/shaders/ScreenCopy_Fragment.glsl');
        this.screenCopyFragmentShader = await scf.text();

        this.screenCopyMaterial = new THREE.ShaderMaterial({
            uniforms: this.screenCopyUniforms,
            vertexShader: this.pathTracingVertexShader,
            fragmentShader: this.screenCopyFragmentShader,
            depthWrite: false,
            depthTest: false
        });

        this.screenCopyMesh = new THREE.Mesh(this.screenCopyGeometry, this.screenCopyMaterial);
        this.screenCopyScene.add(this.screenCopyMesh);


        const sofs = await fetch(shader2);
        this.screenOutputFragmentShader = await sofs.text();

        this.screenOutputMaterial = new THREE.ShaderMaterial({
            uniforms: this.screenOutputUniforms,
            vertexShader: this.pathTracingVertexShader,
            fragmentShader: this.screenOutputFragmentShader,
            depthWrite: false,
            depthTest: false
        });

        //this.screenOutputMaterial = new THREE.MeshBasicMaterial({map: this.BigTextures[0].tex});
        

        this.screenOutputMesh = new THREE.Mesh(this.screenOutputGeometry, this.screenOutputMaterial);
        this.screenOutputScene.add(this.screenOutputMesh);

        this.resizeCanvasToDisplaySize();

        
        this.addSphere(this.SkyBox, 0.1, new THREE.Vector3(0, 0, 0), new THREE.Vector3(0.5, 0.5, 0.8), new THREE.Vector3(0.5, 0.5, 0.8), 0.1, RT_SKYBOX); // Blueish sky light, z, 0.2, RT_LIGHT);
        this.addPointLight(this.shadowSrc, new THREE.Vector3(2,2,0), new THREE.Vector3(0.8,0.8,0.8), 100.0);

        
        this.ready = true;
    }

    
    drawMesh(m, pipe =null, parentTransform=null) {

        if(!m)
            return;

        if(m.geometry) {

            const g = m.geometry;
            let t;

            if(parentTransform !== null) {
                t = new Transformation3();
                parentTransform.multiply2(g.transformation, t);
            }else   
                t = g.transformation;

            if(g.triangles.r){

                const matArray = this.matrix_array.subarray(this.nGeometries * 32, (this.nGeometries + 1) * 32);
    
                matArray[0] = g.triangles.r.start / ( 16 * 4);
                matArray[1] = g.aabbs.r.start / ( 8 * 4);
        
                matArray[2] = g.triangles.n;
                matArray[3] = g.aabbs.n;
    
                this.it = new Transformation3();
                
    
                t.getViewTransform(this.it);
        
                //matrix.clone().invert().toArray(mM);
        
                matArray[4] = this.it.m3[0];
                matArray[5] = this.it.m3[1];
                matArray[6] = this.it.m3[2];
                matArray[7] = this.it.m3[3];
        
                matArray[8] = this.it.m3[4];
                matArray[9] = this.it.m3[5];
                matArray[10] = this.it.m3[6];
                matArray[11] = this.it.m3[7];
        
                matArray[12] = this.it.m3[8];
                matArray[13] = this.it.position.x;
                matArray[14] = this.it.position.y;
                matArray[15] = this.it.position.z;
    
                matArray[16] = m.castShadow ? 1 : 0;
                matArray[17] = 0.0;
                matArray[18] = 0.0;
                matArray[19] = 0.0;
        
                matArray[20] = 0.0;
                matArray[21] = 0.0;
                matArray[22] = 0.0;
                matArray[23] = 0.0;
        
                matArray[24] = 0.0;
        
                this.nGeometries++;
            }
                
            for(let n=0;n<m.children.length;n++){
                this.drawMesh(m.children[n], null, t);
            }

            return;
        }

        if(m.light) {

            const lightArray = this.matrix_array.subarray(FIRST_LIGHT + this.numLights * 12, FIRST_LIGHT + (this.numLights + 1) * 12);
            const l = m.light;

            lightArray[0] = l.object.position.x;
            lightArray[1] = l.object.position.y;
            lightArray[2] = l.object.position.z;
            lightArray[3] = l.radius;

            lightArray[4] = l.mat.color.r;
            lightArray[5] = l.mat.color.g;
            lightArray[6] = l.mat.color.b;
            lightArray[7] = l.angle;

            lightArray[8] = l.dir.x;
            lightArray[9] = l.dir.y;
            lightArray[10] = l.dir.z;
            lightArray[11] = l.type;

            this.numLights++;

            return;
        }

        if(m.sphere) {

            const sphereArray = this.matrix_array.subarray(FIRST_SPHERE + this.numSpheres * 12, FIRST_SPHERE + (this.numSpheres + 1) * 12);
            const s = m.sphere;

            sphereArray[0] = m.object.position.x;
            sphereArray[1] = m.object.position.y;
            sphereArray[2] = m.object.position.z;
            sphereArray[3] = s.radius;

            sphereArray[4] = m.mat.color.r;
            sphereArray[5] = m.mat.color.g;
            sphereArray[6] = m.mat.color.b;
            sphereArray[7] = s.roughness;

            sphereArray[8] = s.emission.r;
            sphereArray[9] = s.emission.g;
            sphereArray[10] = s.emission.b;
            sphereArray[11] = s.type;

            this.numSpheres++;

            return;
        }
        
        if(m.box)
        {
            const cubeArray = this.matrix_array.subarray(FIRST_BOX + this.numCubes * 12, FIRST_BOX + (this.numCubes + 1) * 12);
            const box = m.box;

            cubeArray[0] = box.min.x;
            cubeArray[1] = box.min.y;
            cubeArray[2] = box.min.z;
            cubeArray[3] = box.max.x;

            cubeArray[4] = box.max.y;
            cubeArray[5] = box.max.z;
            cubeArray[6] = box.roughness;
            cubeArray[7] = box.type;

            cubeArray[8] = m.mat.color.r;
            cubeArray[9] = m.mat.color.g;
            cubeArray[10] = m.mat.color.b;
            cubeArray[11] = 0;

            //console.log('add box ', cubeArray);

            this.numCubes++;
            return;
        }

        if(m.cylinder) {
            
            const CylinderArray = this.matrix_array.subarray(FIRST_CYLINDER + this.numCylinders * 12, FIRST_CYLINDER + (this.numCylinders + 1) * 12);
            const cyl = m.cylinder;
            
            CylinderArray[0] = cyl.p1.x;
            CylinderArray[1] = cyl.p1.y;
            CylinderArray[2] = cyl.p1.z;
            CylinderArray[3] = cyl.radius;

            CylinderArray[4] = cyl.p2.x;
            CylinderArray[5] = cyl.p2.y;
            CylinderArray[6] = cyl.p2.z;
            CylinderArray[7] = cyl.roughness;

            CylinderArray[8] = m.mat.color.r;
            CylinderArray[9] = m.mat.color.g;
            CylinderArray[10] = m.mat.color.b;
            CylinderArray[11] = cyl.type;

            
            this.numCylinders++;
            return;
        }
    }

    updateParticle(pMesh, dt, copyEncoder) {

        
        //const b = this.device.createBuffer({ size:  (pMesh.geometry.triangles.n * 3 ) * 64 * 4, usage: GPUBufferUsage.MAP_WRITE | GPUBufferUsage.COPY_SRC, mappedAtCreation: true});
        //const vertexBuffer =  new Float32Array(b.getMappedRange());
        const sc = new THREE.Vector3();
        const pos = new THREE.Vector3();
        const quat = new THREE.Quaternion();

        this.camera.matrixWorld.decompose(pos,quat, sc);
        
        this.cameraTransform.set(pos, quat);

        const g = pMesh.particles.particleMesh.geometry;
        pMesh.particles.update(dt, this.cameraTransform);

        const curTris = pMesh.particles.particleCount * 2;

        this.triangeBuffer.initializeStagingBuffer(curTris * 36 , copyEncoder);
        this.aabbBuffer.initializeStagingBuffer(curTris * 8 * 4 , copyEncoder);

        const triArray = this.triangeBuffer.getStagingRange(curTris * 36);
        const aabArrayBuffer = this.aabbBuffer.getStagingRange(0);

        const pathTracingMaterialList =[pMesh.particles.mat];
        const triangleMaterialMarkers = [g.attributes.position.array.length / 3];

        const materialArray = this.matrix_array.subarray(FIRST_MAT + pMesh.matid * 16, FIRST_MAT + (pMesh.matid + pathTracingMaterialList.length) * 16);

        const infos = this.meshCollision.writeParticleMeshBuffer(g, pMesh.particles.particleCount, triArray, aabArrayBuffer, materialArray, triangleMaterialMarkers, pathTracingMaterialList, pMesh.matid, this.cameraTransform);

        pMesh.geometry.triangles.n = infos.t;
        pMesh.geometry.aabbs.n = infos.a;

        this.triangeBuffer.commitStagingRange(pMesh.geometry.triangles.r, pMesh.geometry.triangles.n  * 36);
        this.aabbBuffer.commitStagingRange(pMesh.geometry.aabbs.r, pMesh.geometry.aabbs.n * 8);


    }

    removeAllParticles(){

        let p = null;
        while((p = this.particles.pop()) != null){
            this.removeMesh(p);
        }

    }

    addParticles(particles, matType = RT_DIFF, transformation = new Transformation3()) {

        const g = particles.particleMesh.geometry;

        particles.mat = {   type: matType, 
                            albedoTextureID: this.addRTMap(particles.particleTexture), 
                            normalTextureID: -1, 
                            color: {r: 1.0,g: 1.0,b: 1.0},
                            emissive: {r: 0.0,g: 0.0,b: 0.0},
                            roughness: 0.5,
                            metalness: 0.2,
                            opacity: 0.5,
                            bumpMap : false,
                            transparent : 1,
                            refractiveIndex: 1.0}

        const pathTracingMaterialList =[particles.mat];
        const triangleMaterialMarkers = [g.attributes.position.array.length / 3];

        const nParticles = g.attributes.position.array.length / 3;
        const curTris = nParticles * 2;

        this.triangeBuffer.initializeStagingBuffer(curTris * 36 , this.renderer);
        this.aabbBuffer.initializeStagingBuffer(curTris * 8 * 4 , this.renderer);

        const triArray = this.triangeBuffer.getStagingRange(curTris * 36);
        const aabArrayBuffer = this.aabbBuffer.getStagingRange(0);

        this.cameraTransform.set(this.camera.position, this.camera.quaternion);

        const materialArray = this.matrix_array.subarray(FIRST_MAT + this.numMaterials * 16, FIRST_MAT + (this.numMaterials + pathTracingMaterialList.length) * 16);

        const infos = this.meshCollision.writeParticleMeshBuffer(g, nParticles, triArray, aabArrayBuffer, materialArray, triangleMaterialMarkers, pathTracingMaterialList, this.numMaterials, this.cameraTransform);

        const triangleRange = this.triangeBuffer.getBufferRange(infos.t * 36);
        const aabbRange = this.aabbBuffer.getBufferRange(infos.a * 8 * 4);
       

        console.log('addParticles triangleRange '+ infos.t  + ' ' + triangleRange.start + '-' + triangleRange.end);
        console.log('addParticles aabbRange ' + infos.a  + ' ' + aabbRange.start + '-' + aabbRange.end);

        this.triangeBuffer.commitStagingRange(triangleRange, infos.t  * 36);
        this.aabbBuffer.commitStagingRange(aabbRange, infos.a * 8);

        const tex = [];
        for (let n = 0; n < this.BigTextures.length; n++) {
            tex.push({type : 't' , value : this.BigTextures[n].tex});
        }
        this.pathTracingUniforms.tAlbedoTextures = { value: tex };
        this.pathTracingUniforms.uAlbedoCoords= { value: this.uniqueMaterialTexturesCoords };
        this.pathTracingUniforms.uAlbedoTexturesIds= { value:this.uniqueMaterialTexturesTids};

        const newParticles = {  particles: particles, 
                                castShadow : true,
                                children: [],
                                matid : this.numMaterials,
                                geometry : {transformation: transformation ,triangles: {n: infos.t, r: triangleRange}, aabbs : {n : infos.a, r: aabbRange}}};

                            
        this.numMaterials += pathTracingMaterialList.length;                                
        newParticles.id = this.particlesId++;
        this.particles.push(newParticles);
        return newParticles;
    }


    addRTData(geo, transformation, triangleMaterialMarkers, pathTracingMaterialList, name = null) {
        if (!geo)
            return;

        if (!geo.attributes)
            return;


        if((geo.index && !this.isIndexed) || (!geo.index && this.isIndexed)){
            console.error('mesh indexing mismatch ');
            return;
        }

        const curTris = geo.attributes.position.array.length / 9;

        this.triangeBuffer.initializeStagingBuffer(curTris * 36 , this.renderer);
        this.aabbBuffer.initializeStagingBuffer(curTris * 8 * 4 , this.renderer);

        const triArray = this.triangeBuffer.getStagingRange(curTris * 36);
        const aabArrayBuffer = this.aabbBuffer.getStagingRange(0);

        if((FIRST_MAT + (this.numMaterials + pathTracingMaterialList.length) * 16)>=this.matrix_array.length){
            console.warn('material buffer full');
            return;
        }

        const matIDX = this.numMaterials;
        const materialArray = this.matrix_array.subarray(FIRST_MAT +  matIDX * 16, FIRST_MAT + (matIDX + pathTracingMaterialList.length) * 16);
        
        const infos = this.meshCollision.writeMeshBuffer(geo, curTris, triArray, aabArrayBuffer, materialArray,  triangleMaterialMarkers, pathTracingMaterialList, this.numMaterials);

        const triangleRange = this.triangeBuffer.getBufferRange(infos.t * 36, name);
        const aabbRange = this.aabbBuffer.getBufferRange(infos.a * 8, name);

        this.numMaterials += pathTracingMaterialList.length;

        //console.log('addRTData triangleRange '+ infos.t  + ' ' + triangleRange.start + '-' + triangleRange.end);
        //console.log('addRTData aabbRange ' + infos.a  + ' ' + aabbRange.start + '-' + aabbRange.end);
        //console.log('addRTData materials ' + this.numMaterials);

        this.triangeBuffer.commitStagingRange(triangleRange, infos.t  * 36);
        this.aabbBuffer.commitStagingRange(aabbRange, infos.a * 8);

        const tex = [];
        for (let n = 0; n < this.BigTextures.length; n++) {
            tex.push(this.BigTextures[n].tex);
        }


        this.pathTracingUniforms.tAlbedoTextures = { value: tex };
        this.pathTracingUniforms.uAlbedoCoords = { value: this.uniqueMaterialTexturesCoords };
        this.pathTracingUniforms.uAlbedoTexturesIds = { value: this.uniqueMaterialTexturesTids };

        return {castShadow : true, geometry : {transformation: transformation ,triangles: {n: infos.t, r: triangleRange}, aabbs : {n : infos.a, r: aabbRange}}, materials : pathTracingMaterialList, children: []};
    }

    enableRender(on) {
        var glDom = document.getElementById('gl-dom');
        if (glDom !== null) {
            glDom.innerHTML = '';


            if (on){

                this.frameCounter = 0;
                this.sampleCounter = 1;
                this.cameraIsMoving = false;
                glDom.appendChild(this.renderer.domElement);
            }
                
        }
    }

    compileShaders() {

        this.renderer.compile(this.pathTracingScene, this.camera);
        this.renderer.compile(this.screenCopyScene, this.camera);
        this.renderer.compile(this.screenOutputScene, this.camera);
    }



    initScene() {
        
        this.nGeometries = 0;
        this.numSpheres = 0;
        this.numCylinders = 0;
        this.numCubes = 0;
        this.numLights = 0;
        this.lastTexId = 1;
        this.lastGeoList = 0;

        this.uniqueMaterialTextures = [];
        this.uniqueMaterialTexturesTids = new Array(256);
        this.uniqueMaterialTexturesCoords = new Array(256);

        for (let n = 0; n < this.uniqueMaterialTexturesCoords.length; n++) {
            this.uniqueMaterialTexturesCoords[n] = new THREE.Vector4(0, 0, 0, 0);
        }

        this.matrix_array.fill(0, 0, this.matrix_array.length);
        this.MatrixDataTexture.needsUpdate = true;

        this.pathTracingUniforms.uNumCubes = { type: "i", value: this.numCubes };
        this.pathTracingUniforms.uNumCylinders = { type: "i", value: this.numCylinders };
        this.pathTracingUniforms.uNumLights = { type: "i", value: this.numLights };
        this.pathTracingUniforms.uNumSpheres = { type: "i", value: this.numSpheres };
        this.pathTracingUniforms.uNumGeometries = { type: "i", value: this.nGeometries };

     
        // set camera's field of view
        this.focusDistance = 1000.0;
        this.apertureSize = 0.0;
        this.cameraRecentlyMoving = false;

        this.cameraIsMoving = true;
        this.sampleCounter = 1;
        this.frameCounter = 0;

    }

    addFire(pos) {
    }
    addSand (pos){
        
    }

    addRTMap(map, name) {

        let tid = -1;

        /*
        if( this.uniqueMaterialTextures.length>=64)
            return tid;
        */

        if (map === null)
            return tid;

        if ((map.source === null)|| (map.source.data === null))
        {
            console.warn('null map', map.source, map.source.data);
            return tid;
        }

        if(map.source.data.currentSrc)
        {
            for (let n = 0; n < this.uniqueMaterialTextures.length; n++) {
                if (this.uniqueMaterialTextures[n] == map.source.data.currentSrc)
                    return n;
            }
        }else{
            for (let n = 0; n < this.uniqueMaterialTextures.length; n++) {
                if (this.uniqueMaterialTextures[n] == name)
                    return n;
            }
        }

        let ret = null;

        while (ret === null) {
            ret = this.lastBigTexture.addTexture(map);

            if (!ret) {
                this.lastBigTexture = new bigTex(this.renderer);
                this.BigTextures.push(this.lastBigTexture);
            }
        }

        tid = this.uniqueMaterialTextures.length;

        const texId = map.source.data.currentSrc ?map.source.data.currentSrc:name;

        this.uniqueMaterialTextures.push(texId);
        this.uniqueMaterialTexturesTids[tid] = this.BigTextures.length - 1;
        this.uniqueMaterialTexturesCoords[tid].set(ret.pos.x, ret.pos.y, ret.size.x, ret.size.y);

        console.log('addRTMap uniqueMaterialTextures', this.uniqueMaterialTextures);
        console.log('addRTMap uniqueMaterialTexturesTids', this.uniqueMaterialTexturesTids);
        console.log('addRTMap uniqueMaterialTexturesCoords', this.uniqueMaterialTexturesCoords);
        console.log('addRTMap BigTextures', this.BigTextures);


        this.lastTexId++;
        return tid;
    }
    
    addBox(c, size, position, color, roughness, type) {

        const minC = position.clone().sub(size.multiplyScalar(0.5));
        const maxC = position.clone().add(size);
        
        c.mat = { color: { r: color.x, g: color.y, b: color.z } };
        c.object = { position: { x: position.x, y: position.y, z: position.z } };
        c.meshGPU = {box : {min : minC, max: maxC, roughness: roughness, type: type}, object: c.object, mat:c.mat};
    }

    
    addCylinder(c, radius, position, height, quat, color, roughness, type) {
        const hx = new THREE.Vector3(0, height / 2, 0).applyQuaternion(quat);

        const p1 = {
            x: position.x + hx.x,
            y: position.y + hx.y,
            z: position.z + hx.z
        };

        const p2 = {
            x: position.x - hx.x,
            y: position.y - hx.y,
            z: position.z - hx.z
        };

        const p = new THREE.Vector3(position.x, position.y, position.z);
        const q = new THREE.Quaternion(quat.x,quat.y,quat.z,quat.w);

        c.mat = { color: { r: color.x, g: color.y, b: color.z } };
        c.object = { position: p, quaternion: q };
        c.meshGPU = {cylinder : {radius: radius, type: type, roughness: roughness, p1: p1, p2: p2}, object : c.object, mat: c.mat};
    }

    addSphere(c, radius, position, emission, color, roughness, type) {

        c.mat = { color: { r: color.x, g: color.y, b: color.z }, emissive: { r: emission.x, g: emission.y, b: emission.z } };
        c.object = { position: { x: position.x, y: position.y, z: position.z } };
        c.meshGPU = {sphere : {radius : radius, emission: { r: emission.x, g: emission.y, b: emission.z}, roughness: roughness, type: type}, object: c.object, mat: c.mat};

    }

    addLight(c, position, color, radius, type) {
        c.mat = { color: { r: color.x, g: color.y, b: color.z } };
        c.object = { position: { x: position.x, y: position.y, z: position.z } };
        c.meshGPU = {light : {  type : type, 
                                radius : radius, 
                                angle : 0, 
                                dir : {x: 0, y: 0, z: 0}, 
                                object: c.object, 
                                mat: c.mat
                             }
                    };
    }

    setSunLight(pos, target) {
        /*
        this.SunSphere = {};
        this.addSphere(this.SunSphere, 10000.0, new THREE.Vector3(0, 0, 0), new THREE.Vector3(0.5, 0.7, 1.0).multiplyScalar(0.01), new THREE.Vector3(0, 0, 0), 0.1, RT_LIGHT); // Blueish sky light, z, 0.2, RT_LIGHT);
        */
    }

    addPointLight(sp, position, color, radius) {

        sp.mat = { color: { r: color.x, g: color.y, b: color.z } };
        sp.object = { position: { x: position.x, y: position.y, z: position.z } };
        sp.meshGPU = {light : {  type : RT_POINT_LIGHT, 
                                radius : radius, 
                                angle : 0.0,
                                dir : {x: 0, y: 0, z: 0}, 
                                object: sp.object, 
                                mat: sp.mat
                             }
                    };
    }

    addSpotLight(sp, position, dir, color, radius, aa) {
        sp.mat = { color: { r: color.x, g: color.y, b: color.z } };
        sp.object = { position: { x: position.x, y: position.y, z: position.z } };
        sp.meshGPU = {light : {  type : RT_SPOT_LIGHT, 
                                radius : radius, 
                                angle : aa,
                                dir : {x: dir.x, y: dir.y, z: dir.z}, 
                                object: sp.object, 
                                mat: sp.mat
                             }
                    };
    }

    setEmission(m, name, r, g, b, i = null){ 

        const mesh = m.meshGPU ? m.meshGPU: m;

        if(!mesh.materials)
            return;

        for(let mat of mesh.materials){

            if((name === null)||(mat.name === name)){

                if(r !== null)
                    mat.emissive.r = r;

                if(g !== null)
                    mat.emissive.g = g;
                
                if(b !== null)
                    mat.emissive.b = b;

                if( i!= null)
                    mat.emissiveIntensity = i;

                //const materialArray = this.matrix_array.subarray(FIRST_MAT + mat.matId * 16, FIRST_MAT + (mat.matId + 1) * 16);

                const idx = FIRST_MAT + mat.matId * 16;

                this.matrix_array[idx+7] = mat.emissive.r;
                this.matrix_array[idx+8] = mat.emissive.g;
                this.matrix_array[idx+9] = mat.emissive.b;
                this.matrix_array[idx+12] = mat.emissiveIntensity; // a or w
                
                return;
            }
        }

    }

    setTextureOffset(m, name, offsetx = null, offsety = null, sizex = null, sizey = null){

        const mesh = m.meshGPU ? m.meshGPU: m;

        if(!mesh.materials)
            return;

        for(let mat of mesh.materials){

            if((name === null)||(mat.name === name)){

                //const materialArray = this.matrix_array.subarray(FIRST_MAT + mat.matId * 16, FIRST_MAT + (mat.matId + 1) * 16);

                const idx = FIRST_MAT + mat.matId * 16

                if(offsetx !== null)
                    this.matrix_array[idx+13] = offsetx; // g or y

                if(offsety !== null)
                    this.matrix_array[idx+14] = offsety; // b or z

                if(sizex !== null)
                    this.matrix_array[idx+15] = sizex; // b or z

                return;
            }
        }

    }

    setColor(m, name, r, g, b){ 

        const mesh = m.meshGPU ? m.meshGPU: m;

        if(!mesh.materials)
            return;

        for(let mat of mesh.materials){

            if((name === null)||(mat.name === name)){

                if(r)
                    mat.color.r = r;

                if(g)
                    mat.color.g = g;
                
                if(b)
                    mat.color.b = b;

                //const materialArray = this.matrix_array.subarray(FIRST_MAT + mat.matId * 16, FIRST_MAT + (mat.matId + 1) * 16);

                const idx = FIRST_MAT + mat.matId * 16;

                this.matrix_array[idx+1] = mat.color.r; // g or y
                this.matrix_array[idx+2] = mat.color.g; // b or z
                this.matrix_array[idx+3] = mat.color.b; // a or w

                return;
            }
        }

    }

    setLightIntensity(sp ,i ){
        sp.meshGPU.light.intensity = i;
    }
    
    addRectLight(sp, pos, target, color, width, height, i) {
        sp.mat = { color: { r: color.x, g: color.y, b: color.z } };
        sp.object = { position: { x: pos.x, y: pos.y, z: pos.z } };
        sp.meshGPU = {light : {  type : RT_POINT_LIGHT, 
                                radius : width, 
                                angle : 0.0,
                                dir : {x: 0, y: 0, z: 0}, 
                                object: sp.object, 
                                mat: sp.mat
                             }
                    };
    }
    createTextureCanvas(canvas, flip = true) {
        
        const t = new THREE.Texture(canvas);
        t.flipY = flip;
        t.isCanvas = true;
        return t;
    }
    getColor(mesh, name){ 
        if(mesh.material.length >0){

            for(let m of mesh.material){
                if((name === null)||(m.name === name)){
                    return m.color;
                }
            }
        }else
            return mesh.material.color

        return null;
    }
    setTex(m, name, tex){ 
        const mesh = m.meshGPU ? m.meshGPU : m;

        if(!mesh.geometry)
            return;

        if(!mesh.materials)
            return;

        if(m.material.length <= 0)
            return;

        for(let omat of m.material){

            if((name !== null)&&(omat.name !== name))
                continue;

            omat.map = tex;

            const otex = omat.map;

            for(let mat of mesh.materials){

                if((name === null)||(mat.name === name)){

                    if(mat.albedoTextureID>=0){

                        const uvVec = this.uniqueMaterialTexturesCoords[mat.albedoTextureID];
                        const texId = this.uniqueMaterialTexturesTids[mat.albedoTextureID];
                        const btex = this.BigTextures[texId];
                        const tex = btex.tex;
                        const texPos = new THREE.Vector2(uvVec.x * btex.maxSize, uvVec.y * btex.maxSize);

                        this.renderer.copyTextureToTexture(texPos, otex, tex, 0);
                        tex.needsUpdate = true;
                    }
                    return;
                }
            }
        }

    }
    updateETex(m, name){ 
    }
    updateTex(m, name){

        const mesh = m.meshGPU ? m.meshGPU : m;

        if(!mesh.geometry)
            return;

        if(m.material.length <= 0)
            return;

        for(let omat of m.material){

            if((name !== null)&&(omat.name !== name))
                continue;

            const otex = omat.map;

            if((otex === null)||(!otex.isCanvas))
                continue;

            for(let mat of mesh.materials){

                if((name === null)||(mat.name === name)){

                    if(mat.albedoTextureID>=0){

                        const uvVec = this.uniqueMaterialTexturesCoords[mat.albedoTextureID];
                        const texId = this.uniqueMaterialTexturesTids[mat.albedoTextureID];
                        const btex = this.BigTextures[texId];
                        const tex = btex.tex;
                        const texPos = new THREE.Vector2(uvVec.x * btex.maxSize, uvVec.y * btex.maxSize);

                        this.renderer.copyTextureToTexture(texPos, otex, tex, 0);
                        tex.needsUpdate = true;
                    }
                    return;
                }
            }
        }
    }
    
    addMeshGroup(m)
    {
        const transformation = new Transformation3();
        return {castShadow : false, geometry : {transformation: transformation ,triangles: {n: 0, r: null}, aabbs : {n : 0, r: null}}, materials : [], children: []};

    }
    
    removeSprite(m){
        if (m)
            this.sceneUI.remove(m);
    }
    setCylinderPos(c, radius, center, height, quat) {

        if(!c.meshGPU)
            return;

        if(!c.meshGPU.cylinder)
           return;

        const cyl = c.meshGPU.cylinder;

        c.object.position.set(center.x, center.y, center.z);
        c.object.quaternion.set(quat.x, quat.y, quat.z, quat.w);
       
        cyl.radius = radius;
        
        const hx = new THREE.Vector3(0, height / 2, 0).applyQuaternion(quat);

        cyl.p1.x = c.object.position.x + hx.x;
        cyl.p1.y = c.object.position.y + hx.y;
        cyl.p1.z = c.object.position.z + hx.z;

        cyl.p2.x = c.object.position.x - hx.x;
        cyl.p2.y = c.object.position.y - hx.y;
        cyl.p2.z = c.object.position.z - hx.z;        
    }




    moveSpherePosition(c, x, y, z, r) {
        if(!c.object)
            return;
        
        if (!c.meshGPU)
            return;

        if (!c.meshGPU.sphere)
            return;

        c.object.position.x += x;
        c.object.position.y += y;
        c.object.position.x += z;
        c.meshGPU.sphere.radius = r;
    }

    setSpherePosition(c, x, y, z, radius) {

        if (!c.meshGPU)
            return;

        if (!c.meshGPU.sphere)
            return;

        if(x !== null){
            c.object.position.x = x;
            c.object.position.y = y;
            c.object.position.z = z;
        }
        c.meshGPU.sphere.radius = radius;
    }

    setSphereColor(c, r, g, b) {

        if(r !== null)
            c.mat.color. r = r;

        if(g !== null)
            c.mat.color. g = g;

        if(b !== null)
            c.mat.color. b = b;
    }

    setSphereEmissive(c, r, g, b) {

        if(r !== null){
            c.mat.emissive.r = r;
            c.meshGPU.sphere.emission.r = r;
        }
        
        if(g !== null){
            c.mat.emissive.g = g;
            c.meshGPU.sphere.emission.g = g;
        }

        if(b !== null){
            c.mat.emissive.b = b;
            c.meshGPU.sphere.emission.b = b;
        }
        
    }

    setShadowSource(position, target) {

        this.setLightPosition(this.shadowSrc, position.x, position.y, position.z, 3);
    }

    setLightPosition(c, x, y, z, r) {

        
        if (!c.meshGPU)
            return;

        if (!c.meshGPU.light)
            return;

        if(x !== null)
            c.object.position.x = x;
        
        if(y !== null)
            c.object.position.y = y;
        
        if(z !== null)
            c.object.position.z = z;
        
        c.meshGPU.light.radius = r;
    }

    setLightDir(c, x, y, z, a) {
        if((c.meshGPU)&&(c.meshGPU.light)){
            c.meshGPU.light.dir.x=x;
            c.meshGPU.light.dir.y=y;
            c.meshGPU.light.dir.z=z;
        }
    }

    setLightColor(c, r, g, b) {

        if((c.meshGPU)&&(c.meshGPU.light)){
            c.meshGPU.light.mat.color.r = r;
            c.meshGPU.light.mat.color.g = g;
            c.meshGPU.light.mat.color.b = b;
        }
    }

    removePointLight(sp) {
        this.removeSphere(sp);
    }

    removeSphere(c) {

        if (!c.meshGPU)
            return;

        if (!c.meshGPU.sphere)
            return;

        c.mat = null;
        c.object = null;
        c.meshGPU = null;
    }
    removeBox(c) {

        if(!c.meshGPU)
            return;

        if(!c.meshGPU.box)
           return;

        c.mat = null;
        c.object = null;
        c.meshGPU = null;
    }
    removeCylinder(c) {

        if(!c.meshGPU)
            return;

        if(!c.meshGPU.cylinder)
           return;

        c.mat = null;
        c.object = null;
        c.cylinder = null;
    }

    updateTransform(m, transformation) {

        if(!m.meshGPU)
            return;
        
        if(!m.meshGPU.geometry)
            return;

        m.meshGPU.geometry.transformation.set(transformation.position, transformation.quaternion);
    }


    addMeshInstance(meshGPU, transformation) {


        const mesh = {  geometry :{  transformation: new Transformation3(transformation.position, transformation.quaternion) , 
                                    triangles: {n: meshGPU.geometry.triangles.n, r: null}, 
                                    aabbs : {n : meshGPU.geometry.aabbs.n, r: null},
                                },
                        children: [],
                        name : meshGPU.name, 
                        castShadow : meshGPU.castShadow};

        mesh.geometry.triangles.r = this.triangeBuffer.addRef(meshGPU.geometry.triangles.r);
        mesh.geometry.aabbs.r = this.aabbBuffer.addRef(meshGPU.geometry.aabbs.r);

        return mesh;
    }

    addMeshChild(m, c) {

        const meshGPU = m.meshGPU ?  m.meshGPU : m;
        const child = c.meshGPU ?  c.meshGPU : c;

        meshGPU.children.push(child);
    }



    addMesh(meshGroup, matType = RT_DIFF, transformation = new Transformation3(),  flip = {x: false,y: false,z: false}, useTex = true) {
        const self = this;
        const geoList = [];

        const triangleMaterialMarkers = [];
        const pathTracingMaterialList = [];

        const sx = flip.x ? -1 : 1;
        const sy = flip.y ? -1 : 1;
        const sz = flip.z ? -1 : 1;

        const det = sx * sy * sz;
        const ids =(det > 0) ? [0,1,2]:[2,1,0];

        //console.log('addMesh meshGroup :', meshGroup);

        
        if((meshGroup.isMesh) &&(meshGroup.geometry.attributes.position.count <= 0)) {
            return {
                        geometry : 
                        { 
                            transformation: transformation ,
                            triangles: {n: 0, r: null}, aabbs : {n : 0, r: null}
                        }, 
                        materials : null, 
                        children: []
                    };
        }
        

        if(meshGroup.isSkinnedMesh){

            const geoms = this.getSkelSubMeshes(meshGroup, meshGroup.skeleton);

            console.log(geoms);
            console.log(meshGroup.skeleton.bones);

            const rootMesh =  new THREE.Mesh(geoms['root'], char.originalMesh.material);
            return;
        }
  
        meshGroup.traverse(function (child) {
            if (child.isMesh) {

                //console.log('addMesh child ', child);

                if (child.geometry.index)
                    child.geometry = child.geometry.toNonIndexed();

                if(!child.geometry.attributes.tangent) {
                    if (child.geometry.attributes.uv) {
                        const tangents = generateTangents(child.geometry.attributes.position.array, child.geometry.attributes.normal.array, child.geometry.attributes.uv.array);
                        child.geometry.setAttribute('tangent', new THREE.Float32BufferAttribute(tangents, 4));
                    } else {
                        child.geometry.setAttribute('tangent', new THREE.Float32BufferAttribute(new Float32Array(child.geometry.attributes.position.array.length), 4));
                        child.geometry.setAttribute('uv', new THREE.Float32BufferAttribute(new Float32Array(child.geometry.attributes.position.array.length * 2 / 3), 2));
                    }
                }


                if (child.material.length > 0) {
                    let j = 0;
                    //for (let j = 0; j < child.material.length; j++) {

                    for (let g =0;g<child.geometry.groups.length;g++) {

                        const grp = child.geometry.groups[g];
                        const j = grp.materialIndex;
                        const imat = child.material[j];

                        if( (imat.name.startsWith('center'))||
                            (imat.name.startsWith('bone'))||
                            (imat.name.startsWith('ccube'))||
                            (imat.name.startsWith('Anchor')))
                        continue;

                        let mat = new MaterialObject();

                        mat.name = imat.name;

                        

                        if (imat.name === 'rt_metalcoat')
                            mat.type = RT_METALCOAT;
                        else if (imat.name === 'rt_coat')
                            mat.type = RT_COAT;
                        else if(imat.name.startsWith('Gem'))
                            mat.type = RT_COAT;
                        else if (imat.name === 'rt_carcoat')
                            mat.type = RT_CARCOAT;
                        else if (imat.name.startsWith('inner'))
                            mat.type = RT_DIFF;
                        else if (imat.name.startsWith('Toon'))
                            mat.type = RT_COAT;
                        else if ((child.name === 'tube')&&(imat.name.startsWith('Glass')))
                            mat.type = RT_REFR;
                        else if (imat.name.startsWith('Water'))
                        {
                            mat.type = RT_REFR;                        
                            mat.ior = 1.3;
                        }
                        else if ((imat.name.startsWith('Glass'))||
                                 (imat.name.startsWith('glass'))||
                                 (imat.name.startsWith('Window')))
                            mat.type = RT_SPEC;/*
                        else if (child.name.startsWith('Plane'))
                            mat.type = RT_METALCOAT;*/
                        else
                            mat.type = matType;

                        mat.albedoTextureID = -1;
                        mat.normalTextureID = -1;

                        mat.color = {r : imat.color.r, g : imat.color.g, b : imat.color.b}; //{r:100.0, g:0.5, b:0.25, a : 1.0};
                        mat.roughness = imat.roughness || 0.2;
                        mat.metalness = imat.metalness || 0.2;
                        mat.emissive = imat.emissive || { r:0, g:0, b:0 };
                        mat.opacity = imat.opacity || 1.0;
                        mat.bumpMap = imat.bumpMap ? true : false;
                        mat.refractiveIndex = 1.0;
                        mat.transparent = imat.transparent ? 1.0 : 0.0;
                        mat.ior = imat.ior ? imat.ior : 1.2;

                        let uvScale = { x: 1, y: 1 };
                        let uvOfffset = { x: 0, y: 0 };

                        if(imat.emissiveMap){

                            mat.emissive.r = 0;
                            mat.emissive.g = 0;
                            mat.emissive.b = 0;
    
                        }

                        if (useTex) {
                            if ((imat.map) && (imat.map.source)) {
                                let normMap = null;

                                if ((imat.normalMap) && (imat.normalMap.source))
                                    normMap = imat.normalMap;/*
                                else if ((imat.bumpMap) && (imat.bumpMap.source))
                                    normMap = imat.bumpMap;*/

                                mat.albedoTextureID = self.addRTMap(imat.map, imat.name+'-tex');

                                if(normMap)
                                    mat.normalTextureID = self.addRTMap(normMap, imat.name+'-norm');

                                uvScale = imat.map.repeat;
                                uvOfffset = imat.map.offset;
                            }

                        }

                        pathTracingMaterialList.push(mat);

                        const grpGeo = new THREE.BufferGeometry();
                        const positions = new Float32Array(grp.count * 3);
                        const normals = new Float32Array(grp.count * 3);
                        const uvs = new Float32Array(grp.count * 2);
                        const tangents = new Float32Array(grp.count * 4);

                        for (let v = 0; v < grp.count; v+=3) {
                            for(let i =0;i<3;i++) {

                                positions[(v + i) * 3.0 + 0] = child.geometry.attributes.position.array[(grp.start + v + ids[i]) * 3.0 + 0] * sx;
                                positions[(v + i) * 3.0 + 1] = child.geometry.attributes.position.array[(grp.start + v + ids[i]) * 3.0 + 1] * sy;
                                positions[(v + i) * 3.0 + 2] = child.geometry.attributes.position.array[(grp.start + v + ids[i]) * 3.0 + 2] * sz;

                                normals[(v + i) * 3.0 + 0] = child.geometry.attributes.normal.array[(grp.start + v + ids[i]) * 3.0 + 0] * sx;
                                normals[(v + i) * 3.0 + 1] = child.geometry.attributes.normal.array[(grp.start + v + ids[i]) * 3.0 + 1] * sy;
                                normals[(v + i) * 3.0 + 2] = child.geometry.attributes.normal.array[(grp.start + v + ids[i]) * 3.0 + 2] * sz;

                                tangents[(v + i) * 4.0 + 0] = child.geometry.attributes.tangent.array[(grp.start + v + ids[i]) * 4.0 + 0] * sx;
                                tangents[(v + i) * 4.0 + 1] = child.geometry.attributes.tangent.array[(grp.start + v + ids[i]) * 4.0 + 1] * sy;
                                tangents[(v + i) * 4.0 + 2] = child.geometry.attributes.tangent.array[(grp.start + v + ids[i]) * 4.0 + 2] * sz;
                                tangents[(v + i) * 4.0 + 3] = child.geometry.attributes.tangent.array[(grp.start + v + ids[i]) * 4.0 + 3];

                                uvs[(v + i) * 2.0 + 0] = uvOfffset.x + (child.geometry.attributes.uv.array[(grp.start + v + ids[i]) * 2.0 + 0] * uvScale.x);
                                uvs[(v + i) * 2.0 + 1] = uvOfffset.y + (child.geometry.attributes.uv.array[(grp.start + v + ids[i]) * 2.0 + 1] * uvScale.y);
                            }
                        }

                        grpGeo.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
                        grpGeo.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
                        grpGeo.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
                        grpGeo.setAttribute('tangent', new THREE.Float32BufferAttribute(tangents, 4));

                        geoList.push(grpGeo);
                        triangleMaterialMarkers.push(grpGeo.attributes.position.array.length / 9);
                    }
                } else {
                    let mat = new MaterialObject();

                    mat.name = child.material.name;

                    if (child.material.name === 'rt_metalcoat')
                        mat.type = RT_METALCOAT;
                    else if (child.material.name === 'rt_coat')
                        mat.type = RT_COAT;
                    else if(child.material.name.startsWith('Gem'))
                        mat.type = RT_COAT;
                    else if (child.name.startsWith('Plane'))
                        mat.type = RT_METALCOAT;
                    else if (child.material.name === 'rt_carcoat')
                        mat.type = RT_CARCOAT;
                    else if ((child.name === 'tube')&&(child.material.name.startsWith('Glass'))){
                        mat.type = RT_REFR;
                    }
                    else if (child.material.name.startsWith('Water')) {
                        mat.type = RT_REFR;                        
                        mat.ior = 1.3;
                    }
                    else if ((child.material.name.startsWith('Glass'))||
                             (child.material.name.startsWith('glass')))
                        mat.type = RT_REFR;                    
                    else
                        mat.type = matType;

                    mat.albedoTextureID = -1;
                    mat.normalTextureID = -1;

                    mat.color = child.material.color; //{r:100.0, g:0.5, b:0.25, a : 1.0};
                    mat.roughness = child.material.roughness || 0.01;
                    mat.metalness = child.material.metalness || 0.2;
                    mat.emissive = child.material.emissive || { r:0, g:0, b:0 };
                    mat.opacity = child.material.opacity || 1.0;
                    mat.bumpMap = child.material.bumpMap ? true : false;
                    mat.ior = child.material.ior ? child.material.ior : 1.2;
                    mat.refractiveIndex = 1.0;
                    mat.transparent = child.material.transparent ? 1.0 : 0.0;

                    if(child.material.emissiveMap){

                        mat.emissive.r = 0;
                        mat.emissive.g = 0;
                        mat.emissive.b = 0;

                    }
                    
                    let uvScale = { x: 1, y: 1 };
                    let uvOfffset = { x: 0, y: 0 };

                    if (useTex) {

                        if ((child.material.map !== null ) && (child.material.map.source !== null)) {
                            let normMap = null;

                            if ((child.material.normalMap) && (child.material.normalMap.source))
                                normMap = child.material.normalMap;
                            /*
                            else if ((child.material.bumpMap) && (child.material.bumpMap.source))
                                normMap = child.material.bumpMap;
                            */

                            mat.albedoTextureID = self.addRTMap(child.material.map, child.material.name+'-tex');

                            if(normMap)
                                mat.normalTextureID = self.addRTMap(normMap, child.material.name+'-norm');

                            uvScale = child.material.map.repeat;
                            uvOfffset = child.material.map.offset;
                        }
                    }

                    if(det<0) {

                        for (let v = 0, uv = 0; v < child.geometry.attributes.position.array.length; v += 9, uv += 6) {

                            let p1 = [child.geometry.attributes.position.array[v + 0], child.geometry.attributes.position.array[v + 1], child.geometry.attributes.position.array[v + 2]];
                            let p2 = [child.geometry.attributes.position.array[v + 3], child.geometry.attributes.position.array[v + 4], child.geometry.attributes.position.array[v + 5]];
                            let p3 = [child.geometry.attributes.position.array[v + 6], child.geometry.attributes.position.array[v + 7], child.geometry.attributes.position.array[v + 8]];

                            let n1 = [child.geometry.attributes.position.array[v + 0], child.geometry.attributes.position.array[v + 1], child.geometry.attributes.position.array[v + 2]];
                            let n2 = [child.geometry.attributes.position.array[v + 3], child.geometry.attributes.position.array[v + 4], child.geometry.attributes.position.array[v + 5]];
                            let n3 = [child.geometry.attributes.position.array[v + 6], child.geometry.attributes.position.array[v + 7], child.geometry.attributes.position.array[v + 8]];

                            let uv0 = [child.geometry.attributes.uv.array[uv + 0], child.geometry.attributes.uv.array[uv + 1]];
                            let uv1 = [child.geometry.attributes.uv.array[uv + 2], child.geometry.attributes.uv.array[uv + 3]];
                            let uv2 = [child.geometry.attributes.uv.array[uv + 4], child.geometry.attributes.uv.array[uv + 5]];

                            child.geometry.attributes.position.array[v + 0] = p3[0] * sx;
                            child.geometry.attributes.position.array[v + 1] = p3[1] * sy;
                            child.geometry.attributes.position.array[v + 2] = p3[2] * sz;

                            child.geometry.attributes.position.array[v + 3] = p2[0] * sx;
                            child.geometry.attributes.position.array[v + 4] = p2[1] * sy;
                            child.geometry.attributes.position.array[v + 5] = p2[2] * sz;

                            child.geometry.attributes.position.array[v + 6] = p1[0] * sx;
                            child.geometry.attributes.position.array[v + 7] = p1[1] * sy;
                            child.geometry.attributes.position.array[v + 8] = p1[2] * sz;

                            child.geometry.attributes.normal.array[v + 0] = n3[0] * sx;
                            child.geometry.attributes.normal.array[v + 1] = n3[1] * sy;
                            child.geometry.attributes.normal.array[v + 2] = n3[2] * sz;

                            child.geometry.attributes.normal.array[v + 3] = n2[0] * sx;
                            child.geometry.attributes.normal.array[v + 4] = n2[1] * sy;
                            child.geometry.attributes.normal.array[v + 5] = n2[2] * sz;

                            child.geometry.attributes.normal.array[v + 6] = n1[0] * sx;
                            child.geometry.attributes.normal.array[v + 7] = n1[1] * sy;
                            child.geometry.attributes.normal.array[v + 8] = n1[2] * sz;

                            if(child.geometry.attributes.uv){
                                child.geometry.attributes.uv.array[uv + 0] = uv2[0] * uvScale.x;
                                child.geometry.attributes.uv.array[uv + 1] = uv2[1] * uvScale.y;
        
                                child.geometry.attributes.uv.array[uv + 0] += uvOfffset.x;
                                child.geometry.attributes.uv.array[uv + 1] += uvOfffset.y;
    
                                child.geometry.attributes.uv.array[uv + 2] = uv1[0] * uvScale.x;
                                child.geometry.attributes.uv.array[uv + 3] = uv1[1] * uvScale.y;
        
                                child.geometry.attributes.uv.array[uv + 2] += uvOfffset.x;
                                child.geometry.attributes.uv.array[uv + 3] += uvOfffset.y;
    
                                child.geometry.attributes.uv.array[uv + 4] = uv0[0] * uvScale.x;
                                child.geometry.attributes.uv.array[uv + 5] = uv0[1] * uvScale.y;
        
                                child.geometry.attributes.uv.array[uv + 4] += uvOfffset.x;
                                child.geometry.attributes.uv.array[uv + 5] += uvOfffset.y;
                            }
                        }
                        
                    } else {

                        for (let v = 0, uv = 0; v < child.geometry.attributes.position.array.length; v += 3, uv+=2) {

                            child.geometry.attributes.position.array[v + 0] *= sx;
                            child.geometry.attributes.position.array[v + 1] *= sy;
                            child.geometry.attributes.position.array[v + 2] *= sz;

                            child.geometry.attributes.normal.array[v + 0] *= sx;
                            child.geometry.attributes.normal.array[v + 1] *= sy;
                            child.geometry.attributes.normal.array[v + 2] *= sz;

                            if(child.geometry.attributes.uv){
                                child.geometry.attributes.uv.array[uv + 0] *= uvScale.x;
                                child.geometry.attributes.uv.array[uv + 1] *= uvScale.y;
        
                                child.geometry.attributes.uv.array[uv + 0] += uvOfffset.x;
                                child.geometry.attributes.uv.array[uv + 1] += uvOfffset.y;
                            }
                        }
                    }

                    pathTracingMaterialList.push(mat);
                    triangleMaterialMarkers.push(child.geometry.attributes.position.array.length / 9);
                    geoList.push(child.geometry);
                }
            }
        });

        if(geoList.length <= 0 )
            return null;

        const geo = mergeGeometries(geoList);

        for (let i = 1; i < triangleMaterialMarkers.length; i++) {
            triangleMaterialMarkers[i] += triangleMaterialMarkers[i - 1];
        }

        //console.log('addMesh geometry : ', geo);
        //console.log('addMesh markers :', triangleMaterialMarkers);
        //console.log('addMesh materials :', pathTracingMaterialList);
        //console.log('addMesh textures :', this.uniqueMaterialTextures);

        return this.addRTData(geo, transformation, triangleMaterialMarkers, pathTracingMaterialList, meshGroup.name);
    }


    destroyObj(m){
    }

    removeMeshChild(p , m){

        const pmesh = p.meshGPU ? p.meshGPU : p;
        const mesh =  m.meshGPU ? m.meshGPU : m;

        let n = 0;
        while(n<pmesh.children.length){
            const child = pmesh.children[n];
            if(child === mesh){
                pmesh.children.splice(n, 1);
            }else
                n++;
        }

    }
    removeMesh(m) {

        if (!m)
            return;

        if (!m.meshGPU)
            return;

        if (!m.meshGPU.geometry)
            return;           

        if(m.meshGPU.geometry.triangles.r)
            this.triangeBuffer.unrefRange(m.meshGPU.geometry.triangles.r);

        if(m.meshGPU.geometry.aabbs.r)
            this.aabbBuffer.unrefRange(m.meshGPU.geometry.aabbs.r);

        this.meshCollision.total_number_of_triangles -= m.meshGPU.geometry.triangles.n;
        this.meshCollision.total_number_of_aabs -= m.meshGPU.geometry.aabbs.n;

        m.meshGPU.geometry.triangles.r = null;
        m.meshGPU.geometry.aabbs.r = null;
        m.meshGPU = null;

        

    }
    enableCameraAnchor(on){

        if(on)
            this.cameraAnchor.add(this.camera);
        else
            this.cameraAnchor.remove(this.camera);
    }

    addRenderPass(name, func) {
        this.renderPass[name] = {drawFunc : func};
    }

    render(dt) {

        if (!this.ready)
            return;

        this.nGeometries = 0;
        this.numSpheres = 0;
        this.numCubes = 0;
        this.numCylinders = 0;
        this.numLights = 0;

        for(let p of this.particles) {
            this.updateParticle(p, dt, this.renderer);
        }

        this.drawMesh(this.SkyBox.meshGPU);
        this.drawMesh(this.shadowSrc.meshGPU);

        if((this.renderPass['main'])&&(this.renderPass['main'].drawFunc!==null))
            this.renderPass['main'].drawFunc();

        this.MatrixDataTexture.needsUpdate = true;
        
        this.pathTracingUniforms.uNumCubes = { type: "i", value: this.numCubes };
        this.pathTracingUniforms.uNumCylinders = { type: "i", value: this.numCylinders };
        this.pathTracingUniforms.uNumSpheres = { type: "i", value: this.numSpheres };
        this.pathTracingUniforms.uNumGeometries = { type: "i", value: this.nGeometries };
        this.pathTracingUniforms.uNumLights = { type: "i", value: this.numLights };
        this.pathTracingUniforms.uFogDensity = { type: "f", value: this.fogDensity };
      
        this.pathTracingUniforms.uApertureSize = { type: "f", value: this.apertureSize };
        this.pathTracingUniforms.uFocusDistance = { type: "f", value: this.focusDistance };

        this.pathTracingUniforms.uTime.value = this.elapsedTime;
        this.pathTracingUniforms.uCameraIsMoving.value = this.cameraIsMoving;
        this.pathTracingUniforms.uSampleCounter.value = this.sampleCounter;
        this.pathTracingUniforms.uFrameCounter.value = this.frameCounter;

        if(this.roadMaT){
            this.pathTracingUniforms.bumpMapScale.value.x = this.roadMaT.bumpMapScale.x;
            this.pathTracingUniforms.bumpMapScale.value.y = this.roadMaT.bumpMapScale.y;
            this.pathTracingUniforms.bumpScale.value = this.roadMaT.bumpScale ;
        }
        

        this.screenOutputUniforms.uSampleCounter.value = this.sampleCounter;
        // PROGRESSIVE SAMPLE WEIGHT (reduces intensity of each successive animation frame's image)
        this.screenOutputUniforms.uOneOverSampleCounter.value = 1.0 / this.sampleCounter;

        const context = this.renderer.getContext();
        
        this.screenOutputUniforms.fScaleX.value = this.renderTargetX / context.drawingBufferWidth;
        this.screenOutputUniforms.fScaleY.value = this.renderTargetY / context.drawingBufferHeight;

        this.camera.updateMatrix();
        this.camera.updateMatrixWorld(true);

        this.pathTracingUniforms.uCameraMatrix.value.copy(this.camera.matrixWorld);


        // RENDERING in 3 steps

        this.pathTracingUniforms.uCameraIsMoving.value = this.cameraIsMoving;
        this.pathTracingUniforms.uSampleCounter.value = this.sampleCounter;
        this.pathTracingUniforms.uFrameCounter.value = this.frameCounter;


        this.screenOutputUniforms.uSampleCounter.value = this.sampleCounter;
        // PROGRESSIVE SAMPLE WEIGHT (reduces intensity of each successive animation frame's image)
        this.screenOutputUniforms.uOneOverSampleCounter.value = 1.0 / this.sampleCounter;


        // STEP 1
        // Perform PathTracing and Render(save) into pathTracingRenderTarget, a full-screen texture.
        // Read previous screenCopyRenderTarget(via texelFetch inside fragment shader) to use as a new starting point to blend with
        this.renderer.setRenderTarget(this.pathTracingRenderTarget);
        this.renderer.render(this.pathTracingScene, this.camera);

        // STEP 2
        // Render(copy) the pathTracingScene output(pathTracingRenderTarget above) into screenCopyRenderTarget.
        // This will be used as a new starting point for Step 1 above (essentially creating ping-pong buffers)

        if(this.accumSample){
            this.renderer.setRenderTarget(this.screenCopyRenderTarget);
            this.renderer.render(this.screenCopyScene, this.quadCamera);
        }
        
        // STEP 3
        // Render full screen quad with generated pathTracingRenderTarget in STEP 1 above.
        // After applying tonemapping and gamma-correction to the image, it will be shown on the screen as the final accumulated output
        this.renderer.setRenderTarget(null);
        this.renderer.render(this.screenOutputScene, this.quadCamera);


        if (this.sceneUI) {
            this.renderer.alpha = true;
            this.renderer.preserveDrawingBuffer = true;
            this.renderer.autoClearDepth = true;
            this.renderer.autoClear = false;
            this.renderer.render(this.sceneUI, this.cameraUI);
        }

        this.totalFrames++;
        this.elapsedTime+=dt;

    }

    async loadPod() {
        await super.loadPod();
        this.podMesh.meshGPU = this.addMesh(this.podMesh, RT_COAT);
    }

    removePod() {

    }
    removeLight(l){

    }
    removeCar(myCar) {

        if(!myCar)
            return;
        
        this.removeMesh(myCar.ChassisMesh);

        for (let w of myCar.wheels) {
            this.removeMesh(w.mesh);
        }

        for (let n = 0; n < myCar.skidPlanes.length; n++) {
            this.removeCylinder(myCar.skidPlanes[n]);
        }

        myCar.skidPlanes = [];

        this.removeTireBox();
        this.removeMotorBox();
        this.removeChassisBox();
    }

    removeCharMesh(mesh){

        for(let c of mesh.children){
            this.removeCharMesh(c);
        }

        this.removeMesh({meshGPU : mesh});

    }
    removeChar(char){

        if(char.avatarMesh){
            this.removeCharMesh(char.avatarMesh.meshGPU);
        }
    }

    addCameraSpaceMesh(mesh ,pos, camSpace = true){

        let meshGPU;

        if(camSpace === true){
            const offset = new THREE.Vector3(pos.x , pos.y , pos.z).applyQuaternion(this.cameraAnchor.quaternion);
            offset.add(this.cameraAnchor.position);
            mesh.position.set(offset.x, offset.y, offset.z);
            mesh.quaternion.set(this.cameraAnchor.quaternion.x, this.cameraAnchor.quaternion.y, this.cameraAnchor.quaternion.z, this.cameraAnchor.quaternion.w);
            mesh.renderOrder = 100;

            const t = new Transformation3();
            t.set(mesh.position, mesh.quaternion);

            if(mesh.isGroup)
                meshGPU = this.addMeshGroup(mesh);
            else
                meshGPU = this.addMesh(mesh);

            mesh.meshGPU = meshGPU;
            
            this.updateTransform(mesh, t);

        }else{
            mesh.position.set(pos.x, pos.y, pos.z);
            mesh.renderOrder = 100;
            const t = new Transformation3();
            t.set(mesh.position, mesh.quaternion);

            meshGPU = this.addMesh(mesh);

            mesh.meshGPU = meshGPU;

            this.updateTransform(mesh, t);
        }
        
        mesh.sx = 1.0;
        mesh.sy = 1.0;

        mesh.ox = 0.0;
        mesh.oy = 0.0;

        mesh.updateMatrixWorld(true);
        

        return meshGPU;

    }

    updateCameraSpaceMesh(mesh, pos){
        const rfov = this.camera.fov * Math.PI / 180.0;
        const fovf = 2 * Math.tan(rfov / 2);

        const offset = new THREE.Vector3(pos.x * fovf * this.camera.aspect + mesh.ox* fovf , pos.y * fovf + mesh.oy* fovf, pos.z).applyQuaternion(this.cameraAnchor.quaternion);
        offset.add(this.cameraAnchor.position);

        mesh.scale.set(mesh.sx * fovf, mesh.sy * fovf, 1.0);
        mesh.position.set(offset.x, offset.y, offset.z);
        mesh.quaternion.set(this.cameraAnchor.quaternion.x, this.cameraAnchor.quaternion.y, this.cameraAnchor.quaternion.z, this.cameraAnchor.quaternion.w);

        const t = new Transformation3();
        t.set(mesh.position, mesh.quaternion);

        this.updateTransform(mesh, t);
    }


    findChildMesh(mesh, name){

        if(mesh.name == name)
            return mesh;

        for(let c of mesh.children){

            const m = this.findChildMesh(c, name);
            if(m !== null)
                return m;
        }
        return null;
    }

    
    updateBoneTransform(m, boneName, q) {

        if(!m.meshGPU)
            return;

        const c  = this.findChildMesh(m.meshGPU, boneName);

        if(c)
            c.geometry.transformation.set(null, q);
    }
    

    addCharMesh(bone, plen, pos, quat, parent, geoms, materials){

        const bonePos = pos ? pos.clone() : new THREE.Vector3(0,0,0);
        const boneQuat = quat ? quat.clone().multiply(bone.quat) : bone.quat.clone();
        const boneRel = new THREE.Vector3(0, plen, 0);
        const boneVec = new THREE.Vector3(0, bone.length, 0).clone().applyQuaternion(boneQuat);
        const nextPos = new THREE.Vector3().addVectors(bonePos, boneVec);

        const mat4 = new THREE.Matrix4().compose(bonePos, boneQuat, new THREE.Vector3(1,1,1));

        const mesh =  new THREE.Mesh(geoms[bone.name], materials);
        mesh.geometry.applyMatrix4(mat4.invert());
        mesh.name = 'bone '+bone.name;

        const meshGPU = this.addMesh(mesh, RT_COAT, new Transformation3(boneRel, bone.quat));   
        meshGPU.name = bone.name;

        this.addMeshChild(parent, meshGPU);
        for(let c of bone.children){
            this.addCharMesh(c, bone.length, nextPos, boneQuat, meshGPU, geoms, materials);
        }
    }


    async addTrackCharacter(char){

        await this.makeCharacter(char);
        
        if(char.skeleton){
            char.originalMesh = char.avatarMesh;

            const geoms = this.getSkelSubMeshes(char.originalMesh, char.skeleton);
            const rootMesh =  new THREE.Mesh(geoms['root'], char.originalMesh.material);
            //rootMesh.geometry.translate(-skeleton.root.pos.x, -skeleton.root.pos.y, -skeleton.root.pos.z);
            const rootGPU = this.addMesh(rootMesh, RT_COAT /*, new Transformation3(skeleton.root.pos)*/);

            rootGPU.name = 'root';

            for(let bone of char.skeleton.root.children){
                this.addCharMesh(bone, char.skeleton.root.pos.y, char.skeleton.root.pos, char.skeleton.root.quat, rootGPU,  geoms, char.originalMesh.material)
            }
            
            char.avatarMesh.meshGPU = rootGPU;
        }
        else
            char.avatarMesh.meshGPU = this.addMesh(char.avatarMesh, RT_COAT, new Transformation3(char.avatarMesh.position, char.avatarMesh.quaternion));

       
    }



    resetAnimation(char){

        const map = char.skeleton.getBoneMap();

        for(let b in map) {
            if(b === 'root')
                continue;
        
            const bone = this.findChildMesh(char.avatarMesh.meshGPU, b);
            if(bone){
                const sb = char.skeleton.findBone(b);
                bone.geometry.transformation.set(null,sb.quat);
            }
        }
    }

    applyAnimation(char, animation, t){

        if(!animation)
            return;

        if(!char.avatarMesh)
            return;

        if(!char.avatarMesh.meshGPU)
            return;

        for(let n=0;n<animation.bones.length;n++){
            const bone = this.findChildMesh(char.avatarMesh.meshGPU, animation.bones[n].name);
            if(bone){
                const q = animation.bones[n].getValue(t);
                bone.geometry.transformation.set(null, q);
            }
        }
    }

    updateRain(time, dt, roadObj){

        super.updateRain(time, dt, roadObj);

        const sc = new THREE.Vector3();
        const pos = new THREE.Vector3();
        const quat = new THREE.Quaternion();

        this.camera.matrixWorld.decompose(pos,quat, sc);
        this.cameraTransform.set(pos, quat);

        const curTris = this.numDrops * 2;

        this.triangeBuffer.initializeStagingBuffer(curTris * 36 , this.renderer);
        this.aabbBuffer.initializeStagingBuffer(curTris * 8 * 4 , this.renderer);

        const triArray = this.triangeBuffer.getStagingRange(curTris * 36);
        const aabArrayBuffer = this.aabbBuffer.getStagingRange(0);

        const pathTracingMaterialList =[this.rainMesh.meshGPU.mat];
        const triangleMaterialMarkers = [this.numDrops];

        const materialArray = this.matrix_array.subarray(FIRST_MAT + this.rainMesh.meshGPU.matid * 16, FIRST_MAT + (this.rainMesh.meshGPU.matid + pathTracingMaterialList.length) * 16);

        const infos = this.meshCollision.writeParticleMeshBuffer(this.rainMesh.geometry, this.numDrops, triArray, aabArrayBuffer, materialArray, triangleMaterialMarkers, pathTracingMaterialList, this.rainMesh.meshGPU.matid, this.cameraTransform);

        this.rainMesh.meshGPU.geometry.triangles.n = infos.t;
        this.rainMesh.meshGPU.geometry.aabbs.n = infos.a;

        this.triangeBuffer.commitStagingRange(this.rainMesh.meshGPU.geometry.triangles.r, this.rainMesh.meshGPU.geometry.triangles.n  * 36);
        this.aabbBuffer.commitStagingRange(this.rainMesh.meshGPU.geometry.aabbs.r, this.rainMesh.meshGPU.geometry.aabbs.n * 8);


    }


    addRain(){
        //this.scene.fog = new THREE.FogExp2(0xAAAAAAA, 0.2);
        const sc = new THREE.Vector3();
        const pos = new THREE.Vector3();
        const quat = new THREE.Quaternion();

        this.camera.matrixWorld.decompose(pos,quat, sc);
        this.cameraTransform.set(pos, quat);

        this.fogDensity = 0.04;

        const g = this.rainMesh.geometry;

        const rainmat = {   type: RT_DIFF, 
                      albedoTextureID: this.addRTMap(this.rainMesh.material.map), 
                      normalTextureID: -1, 
                      color: {r: this.rainColor.x,g: this.rainColor.y,b: this.rainColor.z},
                      emissive: {r: 0.0, g: 0.0, b: 0.1},
                      roughness: 0.5,
                      metalness: 0.2,
                      opacity: 1.0,
                      transparent : 1,
                      refractiveIndex: 1.0}

        const pathTracingMaterialList =[rainmat];
        const triangleMaterialMarkers = [g.attributes.position.array.length / 3];

        const nDrops = g.attributes.position.array.length / 3;
        const curTris = nDrops * 2;

        this.triangeBuffer.initializeStagingBuffer(curTris * 36 , this.renderer);
        this.aabbBuffer.initializeStagingBuffer(curTris * 8 * 4 , this.renderer);

        const triArray = this.triangeBuffer.getStagingRange(curTris * 36);
        const aabArrayBuffer = this.aabbBuffer.getStagingRange(0);



        const materialArray = this.matrix_array.subarray(FIRST_MAT + this.numMaterials * 16, FIRST_MAT + (this.numMaterials + pathTracingMaterialList.length) * 16);

        const infos = this.meshCollision.writeParticleMeshBuffer(g, nDrops, triArray, aabArrayBuffer, materialArray, triangleMaterialMarkers, pathTracingMaterialList, this.numMaterials, this.cameraTransform);

        const triangleRange = this.triangeBuffer.getBufferRange(infos.t * 36);
        const aabbRange = this.aabbBuffer.getBufferRange(infos.a * 8 * 4);
       
        console.log('addRain triangleRange '+ infos.t  + ' ' + triangleRange.start + '-' + triangleRange.end);
        console.log('addRain aabbRange ' + infos.a  + ' ' + aabbRange.start + '-' + aabbRange.end);

        this.triangeBuffer.commitStagingRange(triangleRange, infos.t  * 36);
        this.aabbBuffer.commitStagingRange(aabbRange, infos.a * 8);

        const tex = [];
        for (let n = 0; n < this.BigTextures.length; n++) {
            tex.push(this.BigTextures[n].tex);
        }
        this.pathTracingUniforms.tAlbedoTextures = { value: tex };
        this.pathTracingUniforms.uAlbedoCoords = { value: this.uniqueMaterialTexturesCoords };
        this.pathTracingUniforms.uAlbedoTexturesIds = { value: this.uniqueMaterialTexturesTids };

        const transformation = new Transformation3();

        const newRain = {  children: [],
                           matid : this.numMaterials,
                           mat : rainmat,
                           geometry : {transformation: transformation ,triangles: {n: infos.t, r: triangleRange}, aabbs : {n : infos.a, r: aabbRange}}};

                            
        this.numMaterials += pathTracingMaterialList.length;                                

        this.rainMesh.meshGPU = newRain;
    }

    addDronePart(pt){

        const particles = new ParticleEngine(pt);
        shot_params.positionBase = pt;
        particles.name = 'drone-parts';
        particles.setValues(shot_params);
        particles.initialize();
        return this.addParticles(particles);
    }

    async addCar(myCar, mode) {

        await this.loadCar(myCar, mode);

        myCar.ChassisMesh.meshGPU = this.addMesh(myCar.ChassisMesh, RT_CARCOAT, new Transformation3(myCar.ChassisMesh.position, myCar.ChassisMesh.quaternion));
        for (let w of myCar.wheels) {
            w.mesh.meshGPU = this.addMesh(w.mesh, RT_DIFF, new Transformation3(w.mesh.position, w.mesh.quaternion), w.mesh.position.x > 0 ? { x: true, y: false, z: false } : { x: false, y: false, z: false });
        }

        if(myCar.weaponMesh){

            const wt = new Transformation3(myCar.weaponMesh.position.clone().add(meshsInfos[myCar.carDef.chassis].extents.center), myCar.weaponMesh.quaternion);
            myCar.weaponMesh.meshGPU = this.addMesh(myCar.weaponMesh, RT_DIFF, wt);
            this.setMeshStatic(myCar.weaponMesh, false);
            this.updateTransform(myCar.weaponMesh, wt);
            this.addMeshChild(myCar.ChassisMesh, myCar.weaponMesh);
        }

        if(myCar.weapon){
            const weapon = myCar.weapon;

            weapon.body.meshGPU = this.addMesh(weapon.body, RT_DIFF, new Transformation3({  x : weapon.body.position.x + meshsInfos[myCar.carDef.chassis].extents.center.x,
                                                                                            y : weapon.body.position.y + meshsInfos[myCar.carDef.chassis].extents.center.y,
                                                                                            z : weapon.body.position.z + meshsInfos[myCar.carDef.chassis].extents.center.z}));

            weapon.canon.meshGPU = this.addMesh(weapon.canon, RT_DIFF, new Transformation3({x : weapon.canon.position.x -weapon.head.position.x,
                                                                                            y : weapon.canon.position.y -weapon.head.position.y,
                                                                                            z : weapon.canon.position.z -weapon.head.position.z}));
                                                                                            

            weapon.head.meshGPU = this.addMesh(weapon.head, RT_DIFF, new Transformation3({ x : weapon.head.position.x -weapon.body.position.x,
                                                                                           y : weapon.head.position.y -weapon.body.position.y,
                                                                                           z : weapon.head.position.z -weapon.body.position.z}));                                                                                            
            
            this.setMeshStatic(weapon.head, false);
            this.setMeshStatic(weapon.canon, false);
            this.setMeshStatic(weapon.body, false);

            this.addMeshChild(weapon.head, weapon.canon);
            this.addMeshChild(weapon.body, weapon.head);
            this.addMeshChild(myCar.ChassisMesh, weapon.body);
        }

    
        myCar.getExhaustPos(smoke_params.positionBase);
        
        const particles = new ParticleEngine(smoke_params.positionBase);
        particles.setValues(smoke_params);
        
        particles.initialize();
        myCar.exhaustParticles = this.addParticles(particles);
    }

    async setCar(myCar, mode) {
        await this.loadCar(myCar, mode);

        if(this.podMesh){
            this.podMesh.position.set(0,-0.8,0);
            this.updateTransform(this.podMesh, new Transformation3(this.podMesh.position));
    
        }

           
        const mi = myCar.getMeshInfos();

        myCar.ChassisMesh.quaternion.set(myCar.quat.x, myCar.quat.y, myCar.quat.z, myCar.quat.w);
        myCar.ChassisMesh.position.set(myCar.pos.x, myCar.pos.y + mi.chassisOffset, myCar.pos.z);

        //this.podMesh.meshGPU = this.addMesh(this.podMesh, RT_COAT, new Transformation3(this.podMesh.position, this.podMesh.quaternion));
        myCar.ChassisMesh.meshGPU = this.addMesh(myCar.ChassisMesh, RT_CARCOAT, new Transformation3(myCar.ChassisMesh.position, myCar.ChassisMesh.quaternion));

        for (let w of myCar.wheels) {
            const s = w.scale.x > 0 ? {x: false ,y: false,z: false} : {x: true ,y: false, z:false};
            w.mesh.meshGPU = this.addMesh(w.mesh, RT_DIFF, new Transformation3(w.pos, w.quat), s);
        }

        if(myCar.weaponMesh){
            const wt = new Transformation3(myCar.weaponMesh.position, myCar.weaponMesh.quaternion);
            
            myCar.weaponMesh.meshGPU = this.addMesh(myCar.weaponMesh, RT_DIFF, );
            this.addMeshChild(myCar.ChassisMesh.meshGPU, myCar.weaponMesh.meshGPU);
        }


        myCar.getExhaustPos(smoke_params.positionBase);

        if(this.podMesh)
            this.podMesh.meshGPU.geometry.transformation.position.y = myCar.wheels[0].pos.y - myCar.wheelRadius - 0.25;
        
        const particles = new ParticleEngine(smoke_params.positionBase);
        particles.setValues(smoke_params);
        
        particles.initialize();
        this.addParticles(particles);

        myCar.exhaustParticles = {particles: particles};

        this.frameCounter = 0;
        this.sampleCounter = 1;
    }

    
    updateCharacterSkeleton(char){

        if(!char.skeleton) 
            return;
        
        this.removeChar(char);

        const geoms = this.getSkelSubMeshes(char.originalMesh, char.skeleton);
        const rootMesh =  new THREE.Mesh(geoms['root'], char.originalMesh.material);
        //rootMesh.geometry.translate(-skeleton.root.pos.x, -skeleton.root.pos.y, -skeleton.root.pos.z);
        const rootGPU = this.addMesh(rootMesh, RT_COAT /*, new Transformation3(skeleton.root.pos)*/);

        rootGPU.name = 'root';

        for(let bone of char.skeleton.root.children){
            this.addCharMesh(bone, char.skeleton.root.pos.y, char.skeleton.root.pos, char.skeleton.root.quat, rootGPU,  geoms, char.originalMesh.material)
        }
        char.avatarMesh.meshGPU = rootGPU;
        this.addMesh(char.avatarMesh);

        for(let g of geoms){ g.dispose()};
    }

    addCharObj(char) {

        this.sc = false;

        if(char.skeleton) {
            char.originalMesh = char.avatarMesh.clone();

            const geoms = this.getSkelSubMeshes(char.originalMesh, char.skeleton);
            const rootMesh =  new THREE.Mesh(geoms['root'], char.originalMesh.material);
            rootMesh.name = 'root';
            //rootMesh.geometry.translate(-skeleton.root.pos.x, -skeleton.root.pos.y, -skeleton.root.pos.z);
            const rootGPU = this.addMesh(rootMesh, RT_COAT /*, new Transformation3(skeleton.root.pos)*/);

            for(let bone of char.skeleton.root.children){
                this.addCharMesh(bone, char.skeleton.root.pos.y, char.skeleton.root.pos, char.skeleton.root.quat, rootGPU,  geoms, char.originalMesh.material)
            }
            
            char.avatarMesh.meshGPU = rootGPU;
        }
        else
            char.avatarMesh.meshGPU = this.addMesh(char.avatarMesh, RT_COAT, new Transformation3(char.avatarMesh.position, char.avatarMesh.quaternion));

        char.avatarMesh.quaternion.set(char.quat.x, char.quat.y, char.quat.z, char.quat.w);
        char.avatarMesh.position.set(char.pos.x, char.pos.y, char.pos.z);
        return true;
    }

    async addChar(myChar){

        await this.loadCharacter(myChar);
        this.addCharObj(myChar);
      
    }
    async setChar(myChar){

        await this.loadCharacter(myChar);
        this.addCharObj(myChar);
      
    }

    resizeCanvasToDisplaySize(parDiv) {

        if (!this.pathTracingUniforms)
            return;

        const canvas = this.renderer.domElement;
        // look up the size the canvas is being displayed

        const SCREEN_WIDTH = $('#gl-dom').innerWidth();
        const SCREEN_HEIGHT = $('#gl-dom').innerHeight();

        const context = this.renderer.getContext();

        this.renderer.setSize(SCREEN_WIDTH, SCREEN_HEIGHT);

        let fontAspect = (SCREEN_WIDTH / 175) * (SCREEN_HEIGHT / 200);
        if (fontAspect > 25) fontAspect = 25;
        if (fontAspect < 4) fontAspect = 4;
        fontAspect *= 2;

        this.pathTracingUniforms.uResolution.value.x = this.renderTargetX;
        this.pathTracingUniforms.uResolution.value.y = this.renderTargetY;

        this.pathTracingRenderTarget.setSize(this.renderTargetX, this.renderTargetY);
        this.screenCopyRenderTarget.setSize(context.drawingBufferWidth, context.drawingBufferHeight);

        this.pathTracingRenderTarget.texture.repeat.set(this.renderTargetX / context.drawingBufferWidth, this.renderTargetY / context.drawingBufferHeight);

        /*
        for(let n=0; n<this.screenOutputGeometry.attributes.uv.array.length;n++){
            this.screenOutputGeometry.attributes.uv.array[n * 2 + 0] *= this.renderTargetX / context.drawingBufferWidth;
            this.screenOutputGeometry.attributes.uv.array[n * 2 + 1] *= this.renderTargetY / context.drawingBufferHeight;
        }
        this.screenOutputGeometry.attributes.uv.needsUpdate = true;

        for(let n=0; n<this.screenCopyGeometry.attributes.uv.array.length;n++){
            this.screenCopyGeometry.attributes.uv.array[n * 2 + 0] *= this.renderTargetX / context.drawingBufferWidth;
            this.screenCopyGeometry.attributes.uv.array[n * 2 + 1] *= this.renderTargetY / context.drawingBufferHeight;
        }
        this.screenCopyGeometry.attributes.uv.needsUpdate = true;
        */

        this.camera.aspect = SCREEN_WIDTH / SCREEN_HEIGHT;
        // the following is normally used with traditional rasterized rendering, but it is not needed for our fragment shader raytraced rendering 
        ///worldCamera.updateProjectionMatrix();

        // the following scales all scene objects by the worldCamera's field of view,
        // taking into account the screen aspect ratio and multiplying the uniform uULen,
        // the x-coordinate, by this ratio
        let fovScale = this.camera.fov * 0.5 * (Math.PI / 180.0);
        this.pathTracingUniforms.uVLen.value = Math.tan(fovScale);
        this.pathTracingUniforms.uULen.value = this.pathTracingUniforms.uVLen.value * this.camera.aspect;


        
    }

    async addSkyBox(skyboxImage) {

        this.skyTexture = await this.texLoader.loadAsync(this.assetBase+"/assets/skybox/" + skyboxImage);
        this.skyTexture.wrapS = THREE.RepeatWrapping;
        this.skyTexture.wrapT = THREE.RepeatWrapping;
        this.skyTexture.flipY = true;
        this.skyTexture.minFilter = THREE.LinearFilter;
        this.skyTexture.magFilter = THREE.LinearFilter;
        this.skyTexture.generateMipmaps = false;

        this.setSpherePosition(this.SkyBox, 0, 0, 0, 10000.0);

        console.log('EngineRT.addSkyBox ', this.skyTexture, this.SkyBox);

        this.pathTracingUniforms.tEnvMap = { type: "t", value: this.skyTexture };
    }

    postRender(world) { }
}


export {EngineRT, MeshCollision, bigTex, MaterialObject, RTEngine, filterNoTree, filterEmmissive, FIRST_MAT, FIRST_SPHERE};